import { forwardRef } from "react"

export const BuildingElevationComponent = forwardRef(({ buildingID }, ref) => {
  if (buildingID === "D1") {
    return <D1 ref={ref} />
  } else if (buildingID === "D2") {
    return <D2 ref={ref} />
  } else if (buildingID === "D4") {
    return <D4 ref={ref} />
  } else if (buildingID === "C5") {
    return <C5 ref={ref} />
  } else if (buildingID === "E1") {
    return <E1 ref={ref} />
  } else {
    return null
  }
})

export const E = forwardRef((props, ref) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      width="100%"
      viewBox="0 0 503.11 313.15"
    >
      <g id="e1-block-click">
        <path
          d="M390.34,89.35l-280-.61-.5,57.18H96.22q.19,19.76.42,39.51L405,220.07Z"
          fill="#5c7f66"
          opacity="0.3"
        />
        <polygon
          points="487.97 130.56 487.87 130.56 500.51 311.09 487.97 130.56"
          fill="none"
        />
        <path
          d="M443.33,300.78,430.51,132.7l12.82,168.08,57.18,10.31L487.87,130.57,413.5,132.7l1.55,15.86Q420,195.8,424.93,243H425l13.62,2.58L425,243.05h-.08q-4.94-47.25-9.88-94.48L424.29,243,74.76,198.15l-.62-66.43-13-.41,1.7,94-1.7-94L1.94,129.49l59.18,1.82,13,.41,15.93,0,.14-59.16,317.48.69,5.81,59.42,74.37-2.13-8.75-125L2.21,1.71l-.51,237L62.77,250.3l0-25,13.57.36,0,25.12,341,48.27,5.14-25.44,17,0,3.35,27.16,57.67,10.31ZM347.68,73.15,346.15,4.48Z"
          fill="none"
          stroke="#643287"
          strokeMiterlimit="10"
          strokeWidth="3.39"
        />
        <path
          d="M90.21,72.59l-.14,59.16-15.93,0,.62,66.43L424.29,243l-9.24-94.48q-.82-7.94-1.66-15.86h.11l-5.81-59.42Z"
          fill="none"
          stroke="#643287"
          strokeMiterlimit="10"
          strokeWidth="3.39"
        />
        <path
          d="M415.05,148.56,413.5,132.7h-.11Q414.22,140.64,415.05,148.56Z"
          fill="none"
          stroke="#643287"
          strokeMiterlimit="10"
          strokeWidth="3.39"
        />
        <polyline
          points="479.12 5.55 500.51 311.09 442.84 300.77 439.49 273.62 422.52 273.59 417.38 299.03 76.34 250.76 76.39 225.64 62.82 225.28 62.77 250.3 1.7 238.72"
          fill="none"
        />
        <polygon
          points="488.72 130.56 488.63 130.56 501.26 311.09 488.72 130.56"
          fill="#40657a"
        />
        <path
          d="M444.08,300.78,431.26,132.7l12.82,168.08,57.18,10.31L488.63,130.57l-74.38,2.13,1.55,15.86q4.95,47.24,9.89,94.48h.08l13.61,2.58-13.61-2.58h-.08q-4.95-47.25-9.89-94.48L425,243,75.52,198.15l-.63-66.43-13-.41,1.7,94-1.7-94L2.69,129.49l59.18,1.82,13,.41,15.94,0L91,72.59l317.48.69,5.81,59.42,74.38-2.13-8.75-125L3,1.71l-.51,237L63.52,250.3l0-25,13.58.36-.05,25.12,341,48.27,5.14-25.44,17,0,3.34,27.16,57.67,10.31ZM348.43,73.15,346.9,4.48Z"
          fill="#f1f1f1"
          stroke="#643287"
          strokeMiterlimit="10"
          strokeWidth="3.39"
        />
        <path
          d="M415.8,148.56l-1.55-15.86h-.11Q415,140.64,415.8,148.56Z"
          fill="#40657a"
          stroke="#643287"
          strokeMiterlimit="10"
          strokeWidth="3.39"
        />
        <circle cx="251.86" cy="146.02" r="50.58" fill="#cfc5c6" />
        <text transform="translate(227.48 170)" fill="#887597" fontWeight="700">
          E
        </text>
        <text
          id="e1-num"
          transform="translate(334.74 170)"
          fontSize="60"
          fill="#887597"
          fontWeight="700"
        >
          0
        </text>
      </g>
    </svg>
  )
})
export const Cd = forwardRef((props, ref) => {
  return (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 492.62 705.61"
      height="100%"
      style={{ userSelect: "none" }}
      {...props}
    >
      <g id="c-block-zoom">
        <polygon
          points="337.01 122.34 336.55 334.09 168.88 332.86 169.34 121.98 337.01 122.34"
          style={{
            fill: "#5c7f66",
            isolation: "isolate",
            opacity: "0.300000011920929"
          }}
        />
        <circle cx="252.38" cy="228.03" r="50.58" style={{ fill: "#cfc5c6" }} />
        <text
          transform="translate(222.74 252.01)"
          style={{
            fontSize: "78.13417053222656px",
            fill: "#887597",
            fontFamily: "Lora-Bold, Lora",
            fontWeight: 700
          }}
        >
          C
        </text>
        <text
          transform="translate(241.58 265.3)"
          style={{
            fontSize: "6.783060073852539px",
            fill: "#36194f",
            fontFamily: "NotoSans-Regular, Noto Sans"
          }}
        >
          B
          <tspan
            x="4.41"
            y={0}
            style={{ letterSpacing: "-0.020011939452410483em" }}
          >
            L
          </tspan>
          <tspan x="7.83" y={0}>
            OCK
          </tspan>
        </text>
      </g>
      <g id="c5-block-click" data-name="c5 block-click">
        <polygon
          points="139.6 2.32 139.59 75.73 362.96 75.73 363.03 2.55 139.6 2.32"
          style={{
            fill: "#f1f1f1",
            stroke: "#643287",
            strokeMiterlimit: 10,
            strokeWidth: "3px"
          }}
        />
        <text
          transform="translate(336.26 69.01)"
          style={{
            fontSize: "33.024051666259766px",
            fill: "#887597",
            fontFamily: "NotoSans-Bold, Noto Sans",
            fontWeight: 700
          }}
        >
          5
        </text>
        <text
          id="c5-num"
          transform="translate(228.24 66.19)"
          style={{
            fontSize: "60px",
            fill: "#887597",
            fontFamily: "Lora-Bold, Lora",
            fontWeight: 700
          }}
        >
          0
        </text>
      </g>
      <g id="c4-block-click">
        <polygon
          points="15.2 2.5 138.95 2.27 138.95 145.2 125.3 145.18 125.13 168.78 15.2 169.2 15.2 2.5"
          style={{
            fill: "#f1f1f1",
            stroke: "#643287",
            strokeMiterlimit: 10,
            strokeWidth: "3px"
          }}
        />
        <text
          transform="translate(97.85 159.04)"
          style={{
            fontSize: "33.024051666259766px",
            fill: "#887597",
            fontFamily: "NotoSans-Bold, Noto Sans",
            fontWeight: 700
          }}
        >
          4
        </text>
        <text
          id="c4-num"
          transform="translate(60.48 109.15)"
          style={{
            fontSize: "60px",
            fill: "#887597",
            fontFamily: "Lora-Bold, Lora",
            fontWeight: 700
          }}
        >
          0
        </text>
      </g>
      <g id="c3-block-click">
        <polygon
          points="30.25 169.87 125.14 170.41 124.99 191.62 138.95 191.68 138.95 334.16 15.2 334.16 15.2 206.62 30.48 206.39 30.25 169.87"
          style={{
            fill: "#f1f1f1",
            stroke: "#643287",
            strokeMiterlimit: 10,
            strokeWidth: "3px"
          }}
        />
        <text
          transform="translate(114.23 325.68)"
          style={{
            fontSize: "33.024051666259766px",
            fill: "#887597",
            fontFamily: "NotoSans-Bold, Noto Sans",
            fontWeight: 700
          }}
        >
          3
        </text>
        <text
          id="d3-num"
          transform="translate(60.96 279.09)"
          style={{
            fontSize: "60px",
            fill: "#887597",
            fontFamily: "Lora-Bold, Lora",
            fontWeight: 700
          }}
        >
          0
        </text>
      </g>
      <g id="c2-block-click">
        <polyline
          points="378.16 167 471.71 166.89 471.71 205.21 487.44 205.14 487.46 327.43 362.35 327.43 362.35 190.46 378.12 190.46 378.16 167"
          style={{
            fill: "#f1f1f1",
            stroke: "#643287",
            strokeMiterlimit: 10,
            strokeWidth: "3.45711632323542px"
          }}
        />
        <text
          transform="translate(460.54 318.45)"
          style={{
            fontSize: "33.024051666259766px",
            fill: "#887597",
            fontFamily: "NotoSans-Bold, Noto Sans",
            fontWeight: 700
          }}
        >
          2
        </text>
        <text
          id="c2-num"
          transform="translate(405.83 278.61)"
          style={{
            fontSize: "60px",
            fill: "#887597",
            fontFamily: "Lora-Bold, Lora",
            fontWeight: 700
          }}
        >
          0
        </text>
      </g>
      <g id="c1-block-click">
        <polygon
          points="362.38 1.5 487.46 1.5 487.46 167.01 378.12 167.12 378.12 143.45 362.35 143.45 362.38 1.5"
          style={{
            fill: "#f1f1f1",
            stroke: "#643287",
            strokeMiterlimit: 10,
            strokeWidth: "3px"
          }}
        />
        <text
          transform="translate(460.54 154.76)"
          style={{
            fontSize: "33.024051666259766px",
            fill: "#887597",
            fontFamily: "NotoSans-Bold, Noto Sans",
            fontWeight: 700
          }}
        >
          1
        </text>
        <text
          id="c1-num"
          transform="translate(404.96 109.15)"
          style={{
            fontSize: "60px",
            fill: "#887597",
            fontFamily: "Lora-Bold, Lora",
            fontWeight: 700
          }}
        >
          0
        </text>
      </g>
      <g id="d5-block-click">
        <polyline
          points="4.31 370.92 140.29 370.92 141.16 533.75 28.61 534.81 28.1 500.69 1.73 500.69 1.73 434 14.14 434 14.14 397.29 4.31 397.29 4.31 370.92"
          style={{
            fill: "#f1f1f1",
            stroke: "#643287",
            strokeMiterlimit: 10,
            strokeWidth: "3.45711632323542px"
          }}
        />
        <text
          transform="translate(117.75 525.78)"
          style={{
            fontSize: "33.024051666259766px",
            fill: "#887597",
            fontFamily: "NotoSans-Bold, Noto Sans",
            fontWeight: 700
          }}
        >
          5
        </text>
        <text
          id="d5-num"
          transform="translate(60.48 475.17)"
          style={{
            fontSize: "60px",
            fill: "#887597",
            fontFamily: "Lora-Bold, Lora",
            fontWeight: 700
          }}
        >
          0
        </text>
      </g>
      <g id="d4-block-click">
        <polyline
          points="17.2 534.81 141.16 533.75 142.16 703.65 16.95 703.65 17.2 534.81"
          style={{
            fill: "#f1f1f1",
            stroke: "#643287",
            strokeMiterlimit: 10,
            strokeWidth: "3.45711632323542px"
          }}
        />
        <text
          transform="translate(117 695.89)"
          style={{
            fontSize: "33.024051666259766px",
            fill: "#887597",
            fontFamily: "NotoSans-Bold, Noto Sans",
            fontWeight: 700
          }}
        >
          4
        </text>
        <text
          id="d4-num"
          transform="translate(60.48 648.77)"
          style={{
            fontSize: "60px",
            fill: "#887597",
            fontFamily: "Lora-Bold, Lora",
            fontWeight: 700
          }}
        >
          0
        </text>
      </g>
      <g id="d3-block-click">
        <rect
          x="142.17"
          y="631.45"
          width="222.89"
          height="72.2"
          style={{
            fill: "#f1f1f1",
            stroke: "#643287",
            strokeMiterlimit: 10,
            strokeWidth: "3.45711632323542px"
          }}
        />
        <text
          transform="translate(337.63 695.89)"
          style={{
            fontSize: "33.024051666259766px",
            fill: "#887597",
            fontFamily: "NotoSans-Bold, Noto Sans",
            fontWeight: 700
          }}
        >
          3
        </text>
        <text
          id="d3-num-2"
          data-name="d3-num"
          transform="translate(228.24 692.93)"
          style={{
            fontSize: "60px",
            fill: "#887597",
            fontFamily: "Lora-Bold, Lora",
            fontWeight: 700
          }}
        >
          0
        </text>
      </g>
      <g id="d2-block-click">
        <polygon
          points="380.44 513.22 492.28 512.67 492.28 537.28 474.68 537.28 474.68 575.38 492.28 575.38 492.28 703.65 365.44 703.65 364.02 560.25 379.82 560.25 380.44 513.22"
          style={{
            fill: "#f1f1f1",
            stroke: "#643287",
            strokeMiterlimit: 10,
            strokeWidth: "3.56479719692943px"
          }}
        />
        <text
          transform="translate(465.68 695.89)"
          style={{
            fontSize: "33.024051666259766px",
            fill: "#887597",
            fontFamily: "NotoSans-Bold, Noto Sans",
            fontWeight: 700
          }}
        >
          2
        </text>
        <text
          id="d2-num"
          transform="translate(404.96 648.77)"
          style={{
            fontSize: "60px",
            fill: "#887597",
            fontFamily: "Lora-Bold, Lora",
            fontWeight: 700
          }}
        >
          0
        </text>
      </g>
      <g id="d1-block-click">
        <polyline
          points="363.86 370.92 492.44 370.92 492.44 512.67 364.82 514.41 363.86 370.92"
          style={{
            fill: "#f1f1f1",
            stroke: "#36194f",
            strokeMiterlimit: 10,
            strokeWidth: "3px"
          }}
        />
        <text
          transform="translate(462.04 498.75)"
          style={{
            fontSize: "33.024051666259766px",
            fill: "#887597",
            fontFamily: "NotoSans-Bold, Noto Sans",
            fontWeight: 700
          }}
        >
          1
        </text>
        <text
          id="d1-num"
          transform="translate(405.83 465.92)"
          style={{
            fontSize: "60px",
            fill: "#887597",
            fontFamily: "Lora-Bold, Lora",
            fontWeight: 700
          }}
        >
          0
        </text>
      </g>
      <g id="d-block-zoom">
        <path
          d="M337.42,357.06l-167.67-.36q-.1,44.66-.19,89.32l-.33,145.2,167.38-.66Q337,473.82,337.42,357.06Z"
          style={{
            fill: "#5c7f66",
            isolation: "isolate",
            opacity: "0.300000011920929"
          }}
        />
        <circle cx="253.33" cy="478.53" r="50.58" style={{ fill: "#cfc5c6" }} />
        <text
          transform="translate(225.87 499.68)"
          style={{
            fontSize: "78.13417053222656px",
            fill: "#887597",
            fontFamily: "Lora-Bold, Lora",
            fontWeight: 700
          }}
        >
          D
        </text>
        <text
          transform="translate(242.52 515.79)"
          style={{
            fontSize: "6.783060073852539px",
            fill: "#36194f",
            fontFamily: "NotoSans-Regular, Noto Sans"
          }}
        >
          B
          <tspan
            x="4.41"
            y={0}
            style={{ letterSpacing: "-0.020011939452410483em" }}
          >
            L
          </tspan>
          <tspan x="7.83" y={0}>
            OCK
          </tspan>
        </text>
      </g>
    </svg>
  )
})
export const SitePlan = forwardRef((props, ref) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      height="100%"
      viewBox="0 0 721.37 1171.4"
    >
      <g id="block_e">
        <circle
          id="block_e-2"
          data-name="block_e"
          cx="668.94"
          cy="1072.66"
          r="50.58"
          fill="#cfc5c6"
        />
        <circle id="apt_e" cx="58.41" cy="1072.66" r="50.58" fill="#cfc5c6" />
        <g id="block_e-3" data-name="block_e">
          <text
            transform="translate(644.56 1096.64)"
            fill="#887697"
            fontWeight="700"
          >
            E
          </text>
        </g>
        <g id="apt_no_e">
          <text
            transform="translate(33.58 1096.64)"
            fill="#887697"
            fontWeight="700"
          >
            0
          </text>
        </g>
        <polyline
          points="488.18 1065.08 495.8 1164.11 529.78 1170.19 522.33 1063.82 478.01 1065.08 484.87 1130.09 492.77 1130.09"
          fill="none"
          stroke="#653387"
          strokeMiterlimit="10"
          strokeWidth="2"
        />
        <polygon
          points="516.15 990.16 528.75 1170.19 494.77 1164.11 492.8 1148.11 482.8 1148.09 479.77 1163.08 278.83 1134.64 278.86 1119.84 270.86 1119.63 270.83 1134.37 234.85 1127.55 235.15 987.9 516.15 990.16"
          fill="none"
          stroke="#653387"
          strokeMiterlimit="10"
          strokeWidth="2"
        />
        <polygon
          points="474.06 1030.07 287 1029.66 286.92 1064.52 277.53 1064.5 277.9 1103.64 483.84 1130.09 474.06 1030.07"
          fill="none"
          stroke="#653387"
          strokeMiterlimit="10"
          strokeWidth="2"
        />
        <line
          x1="437.8"
          y1="989.53"
          x2="438.7"
          y2="1029.99"
          fill="none"
          stroke="#653387"
          strokeMiterlimit="10"
        />
        <polyline
          points="277.53 1064.5 269.86 1064.26 234.99 1063.19"
          fill="none"
          stroke="#653387"
          strokeMiterlimit="10"
        />
        <line
          x1="270.86"
          y1="1119.62"
          x2="269.86"
          y2="1064.26"
          fill="none"
          stroke="#653387"
          strokeMiterlimit="10"
        />
        <path
          d="M463.84,1039.54l-165-.36-.3,33.69h-8q.12,11.64.25,23.28l181.7,20.41Z"
          fill="#5c8067"
          opacity="0.3"
        />
        <rect
          id="button_e"
          x="209.33"
          y="956.78"
          width="319.42"
          height="214.1"
          fill="#887697"
        />
      </g>
      <g id="block_d">
        <circle cx="50.58" cy="803.75" r="50.58" fill="#cfc5c6" />
        <g id="apt_no_d">
          <text
            transform="translate(27.95 824.9)"
            fill="#887697"
            fontWeight="700"
          >
            0
          </text>
        </g>
        <line
          x1="304.26"
          y1="871.17"
          x2="304.26"
          y2="912.94"
          fill="#653387"
          stroke="#653387"
          strokeMiterlimit="10"
          strokeWidth="2"
        />
        <line
          x1="304.26"
          y1="814.65"
          x2="239.14"
          y2="814.97"
          fill="#653387"
          stroke="#653387"
          strokeMiterlimit="10"
          strokeWidth="2.5"
        />
        <polyline
          points="432.75 803.46 432.2 720.45 506.58 720.45 506.58 816.7 496.4 816.7 496.4 838.74 506.58 838.74 506.58 912.94 231.82 912.94 231.97 815.27 239.15 815.27 238.85 795.53 223.59 795.53 223.59 756.94 230.77 756.94 230.77 735.71 225.09 735.71 225.09 720.45 303.75 720.45 304.25 871.17 433.2 871.17 432.92 829.38"
          fill="none"
          stroke="#653387"
          strokeMiterlimit="10"
          strokeWidth="2"
        />
        <polyline
          points="432.38 829.98 441.52 829.98 441.52 802.91 431.76 802.91"
          fill="none"
          stroke="#653387"
          strokeMiterlimit="10"
          strokeWidth="2.06"
        />
        <path
          d="M417.22,712.44l-97-.21q-.06,25.83-.11,51.67l-.19,84,96.83-.38Q417,780,417.22,712.44Z"
          fill="#5c8067"
          opacity="0.3"
        />
        <line
          x1="433.2"
          y1="871.17"
          x2="433.2"
          y2="912.94"
          fill="#653387"
          stroke="#653387"
          strokeMiterlimit="10"
          strokeWidth="2"
        />
        <line
          x1="506.41"
          y1="802.75"
          x2="441.29"
          y2="803.07"
          fill="#653387"
          stroke="#653387"
          strokeMiterlimit="10"
          strokeWidth="2.5"
        />
        <circle cx="661.1" cy="803.75" r="50.58" fill="#cfc5c6" />
        <text
          transform="translate(633.65 824.9)"
          fill="#887697"
          fontWeight="700"
        >
          D
        </text>
        <rect
          id="button_d"
          x="208.23"
          y="715.75"
          width="319.42"
          height="214.1"
          fill="#887697"
        />
      </g>
      <g id="block_c">
        <circle cx="60.27" cy="606.77" r="50.58" fill="#cfc5c6" />
        <g id="apt_no_c">
          <text
            transform="translate(32.68 630.75)"
            fill="#887697"
            fontWeight="700"
          >
            0
          </text>
        </g>
        <line
          x1="294.99"
          y1="606.14"
          x2="239.45"
          y2="606.41"
          fill="#653387"
          stroke="#653387"
          strokeMiterlimit="10"
          strokeWidth="1.85"
        />
        <line
          x1="494"
          y1="605.63"
          x2="440.83"
          y2="605.89"
          fill="#653387"
          stroke="#653387"
          strokeMiterlimit="10"
          strokeWidth="1.81"
        />
        <line
          x1="302.49"
          y1="509.82"
          x2="302.49"
          y2="551.59"
          fill="#653387"
          stroke="#653387"
          strokeMiterlimit="10"
          strokeWidth="2"
        />
        <line
          x1="431.73"
          y1="510.78"
          x2="431.73"
          y2="552.54"
          fill="#653387"
          stroke="#653387"
          strokeMiterlimit="10"
          strokeWidth="2"
        />
        <path
          d="M230.89,607.27V510h273.2V605.7H495v22.17l9.09,0,0,70.75H431.71V619.34h9.12V592.07h-9.12V552.29H302.48v40.22l-7.89,0-.18,26.5,8.07,0v82.42H230.89V627.67l8.84-.13q-.06-10.56-.13-21.13l-8.71,0"
          fill="none"
          stroke="#653387"
          strokeMiterlimit="10"
          strokeWidth="2"
        />
        <polygon
          points="417.07 579.86 416.8 702.36 319.8 701.65 320.07 579.65 417.07 579.86"
          fill="#5c8067"
          opacity="0.3"
        />
        <circle cx="670.79" cy="606.77" r="50.58" fill="#cfc5c6" />
        <text
          transform="translate(641.15 630.75)"
          fill="#887697"
          fontWeight="700"
        >
          C
        </text>
        <rect
          id="button_c"
          x="209.33"
          y="496.69"
          width="319.42"
          height="214.1"
          fill="#887697"
        />
      </g>
      <g id="block_b">
        <circle cx="58.89" cy="316.63" r="50.58" fill="#cfc5c6" />
        <g id="apt_no_c-2" data-name="apt_no_c">
          <text
            transform="translate(35.75 340.61)"
            fill="#887697"
            fontWeight="700"
          >
            0
          </text>
        </g>
        <path
          d="M504.25,218.62l-.43,196.67-74,.11V405.21l-23,.14v16l-81.42-.18V405.52l-21.58-.39v10.25l-79-.42L222.25,218l80.63.18V376.13h18v-17l92,1.2v16l16.5-.46q-.15-78.72-.29-157.45Z"
          fill="none"
          stroke="#653387"
          strokeMiterlimit="10"
          strokeWidth="2"
        />
        <path
          d="M482.91,315.51l.22-97"
          fill="none"
          stroke="#653387"
          strokeMiterlimit="10"
        />
        <path
          d="M504,317.06l-74.5-.16"
          fill="none"
          stroke="#653387"
          strokeMiterlimit="10"
        />
        <path
          d="M429.84,405.21q-.21-14.65-.43-29.31"
          fill="none"
          stroke="#653387"
          strokeMiterlimit="10"
          strokeWidth="2"
        />
        <path
          d="M303.44,415.12l-.27-39.62"
          fill="none"
          stroke="#653387"
          strokeMiterlimit="10"
        />
        <path
          d="M303,315.62l-80-.17"
          fill="none"
          stroke="#653387"
          strokeMiterlimit="10"
        />
        <path
          d="M416.27,211.6l-97-.21-.12,51.67-.18,84,97.94.71Q416.6,279.69,416.27,211.6Z"
          fill="#5c8067"
          opacity="0.3"
        />
        <circle cx="669.41" cy="316.63" r="50.58" fill="#cfc5c6" />
        <text
          transform="translate(645.28 340.61)"
          fill="#887697"
          fontWeight="700"
        >
          B
        </text>
        <rect
          id="button_b"
          x="208.23"
          y="217.11"
          width="319.42"
          height="214.1"
          fill="#887697"
        />
      </g>
      <g id="block_a">
        <path
          d="M504.47,8.24l-.39,179.45-73.69-.16.18-84.38,7.7-1v-26l-7.68-.87.27-38.65-21.5.45-.06,26.84h-83l.05-22h-22L304,187.37l-80.21-.18L224,88.1l12.21-.33v-19h-14l.09-41h7l-.27-20,75.81.66v-7L338.76,1l-.4,7h19v6h20V8h19V2l34.5-.43v6Z"
          fill="none"
          stroke="#653387"
          strokeMiterlimit="10"
          strokeWidth="2"
        />
        <line
          x1="430.98"
          y1="7.58"
          x2="430.91"
          y2="36.58"
          fill="none"
          stroke="#653387"
          strokeMiterlimit="10"
        />
        <path
          d="M504.3,89.2l-66-.15"
          fill="none"
          stroke="#653387"
          strokeMiterlimit="10"
        />
        <polyline
          points="482.08 187.2 483.08 187.2 482.3 89.2 483.3 89.2"
          fill="none"
          stroke="#653387"
          strokeMiterlimit="10"
        />
        <path
          d="M304.3,88.3l-80-.17"
          fill="none"
          stroke="#653387"
          strokeMiterlimit="10"
        />
        <line
          x1="304.99"
          y1="0.81"
          x2="304.9"
          y2="41.81"
          fill="none"
          stroke="#653387"
          strokeMiterlimit="10"
        />
        <path
          d="M416.33,76.05l-.67,121.4h0l-96.6.39.27-122Z"
          fill="#5c8067"
          opacity="0.3"
        />
        <circle cx="669.16" cy="98.35" r="50.58" fill="#cfc5c6" />
        <circle cx="58.64" cy="98.35" r="50.58" fill="#cfc5c6" />
        <text
          transform="translate(643.07 119.5)"
          fill="#887697"
          fontWeight="700"
        >
          A
        </text>
        <g id="apt_no_a">
          <text
            transform="translate(33.8 119.5)"
            fill="#887697"
            fontWeight="700"
          >
            0
          </text>
        </g>
        <rect
          id="button_a"
          x="209.33"
          y="0.81"
          width="319.42"
          height="197.03"
          fill="#887697"
        />
      </g>
    </svg>
  )
})
export const C4 = forwardRef((props, ref) => {
  return (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 402.5 712.83"
      width="100%"
      // height="712.83"
      {...props}
    >
      <g id="floors">
        <rect
          id="floor-1"
          x="16.45"
          y="660.39"
          width={383}
          height={50}
          style={{ fill: "none" }}
        />
        <rect
          id="floor-2"
          x="16.45"
          y="608.39"
          width={383}
          height={50}
          style={{ fill: "none" }}
        />
        <rect
          id="floor-3"
          x="16.45"
          y="556.39"
          width={383}
          height={50}
          style={{ fill: "none" }}
        />
        <rect
          id="floor-0"
          x="18.45"
          y="506.39"
          width={383}
          height={50}
          style={{ fill: "none" }}
        />
        <rect
          id="floor-4"
          x="18.45"
          y="452.39"
          width={383}
          height={50}
          style={{ fill: "none" }}
        />
        <rect
          id="floor-5"
          x="18.45"
          y="400.39"
          width={383}
          height={50}
          style={{ fill: "none" }}
        />
        <rect
          id="floor-6"
          x="19.45"
          y="346.39"
          width={383}
          height={50}
          style={{ fill: "none" }}
        />
        <rect
          id="floor-7"
          x="19.45"
          y="294.39"
          width={383}
          height={50}
          style={{ fill: "none" }}
        />
        <rect
          id="floor-8"
          x="19.45"
          y="242.39"
          width={383}
          height={50}
          style={{ fill: "none" }}
        />
        <rect
          id="floor-9"
          x="19.45"
          y="190.39"
          width={383}
          height={50}
          style={{ fill: "none" }}
        />
        <rect
          id="floor-10"
          x="18.45"
          y="138.39"
          width={383}
          height={50}
          style={{ fill: "none" }}
        />
        <rect
          id="floor-11"
          x="18.45"
          y="81.39"
          width={383}
          height={54}
          style={{ fill: "none" }}
        />
      </g>
      <g id="C4">
        <rect
          x="6.5"
          y="535.83"
          width={70}
          height={177}
          style={{ fill: "#371c50" }}
        />
        <rect
          x="19.87"
          y="26.27"
          width="381.13"
          height="685.05"
          style={{
            fill: "none",
            stroke: "#371c50",
            strokeMiterlimit: 10,
            strokeWidth: "3px"
          }}
        />
        <rect
          x="243.2"
          y="86.54"
          width="13.64"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="275.59"
          y="86.8"
          width="13.64"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="243.4"
          y="139.76"
          width="13.64"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="275.79"
          y="140.02"
          width="13.64"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="243.4"
          y="192.76"
          width="13.64"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="275.79"
          y="193.02"
          width="13.64"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="243.4"
          y="245.41"
          width="13.64"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="275.79"
          y="245.67"
          width="13.64"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="243.4"
          y="297.85"
          width="13.64"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="275.79"
          y="298.11"
          width="13.64"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="243.05"
          y="350.8"
          width="13.64"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="275.44"
          y="351.07"
          width="13.64"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="243.05"
          y="403.46"
          width="13.64"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="275.44"
          y="403.72"
          width="13.64"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="243.05"
          y="455.89"
          width="13.64"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="275.44"
          y="456.15"
          width="13.64"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="97.03"
          y="87.17"
          width="13.64"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="129.42"
          y="87.43"
          width="13.64"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="97.22"
          y="140.39"
          width="13.64"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="129.62"
          y="140.65"
          width="13.64"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="97.22"
          y="193.39"
          width="13.64"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="129.62"
          y="193.65"
          width="13.64"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="97.22"
          y="246.04"
          width="13.64"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="129.62"
          y="246.3"
          width="13.64"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="97.22"
          y="298.48"
          width="13.64"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="129.62"
          y="298.74"
          width="13.64"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="96.88"
          y="351.43"
          width="13.64"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="129.27"
          y="351.7"
          width="13.64"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="96.88"
          y="404.09"
          width="13.64"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="129.27"
          y="404.35"
          width="13.64"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="96.88"
          y="456.52"
          width="13.64"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="129.27"
          y="456.78"
          width="13.64"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="97.14"
          y="511.22"
          width="13.64"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="129.53"
          y="511.48"
          width="13.64"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="97.14"
          y="563.65"
          width="13.64"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="129.53"
          y="563.91"
          width="13.64"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="315.62"
          y="86.7"
          width="13.64"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="315.81"
          y="139.91"
          width="13.64"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="315.81"
          y="192.91"
          width="13.64"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="315.81"
          y="245.57"
          width="13.64"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="315.81"
          y={298}
          width="13.64"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="315.46"
          y="350.96"
          width="13.64"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="315.46"
          y="456.04"
          width="13.64"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="358.74"
          y="86.7"
          width="24.41"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="359.09"
          y="139.91"
          width="24.41"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="359.09"
          y="192.91"
          width="24.41"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="359.09"
          y="245.57"
          width="24.41"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="359.09"
          y={298}
          width="24.41"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="358.46"
          y="350.96"
          width="24.41"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="358.46"
          y="403.61"
          width="24.41"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="358.46"
          y="456.04"
          width="24.41"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="41.53"
          y="87.22"
          width="29.55"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="41.95"
          y="140.43"
          width="29.55"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="41.95"
          y="193.43"
          width="29.55"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="41.95"
          y="246.09"
          width="29.55"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="41.95"
          y="298.52"
          width="29.55"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="41.2"
          y="351.48"
          width="29.55"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="41.2"
          y="404.13"
          width="29.55"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="41.2"
          y="456.57"
          width="29.55"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="38.3"
          y="110.28"
          width="36.2"
          height="18.51"
          style={{ fill: "#eee4f9", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="38.08"
          y="163.69"
          width="36.2"
          height="18.51"
          style={{ fill: "#eee4f9", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="38.19"
          y="216.99"
          width="36.2"
          height="18.51"
          style={{ fill: "#eee4f9", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="37.96"
          y="269.4"
          width="36.2"
          height="18.51"
          style={{ fill: "#eee4f9", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="38.24"
          y="321.31"
          width="36.2"
          height="18.51"
          style={{ fill: "#eee4f9", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="38.02"
          y="374.72"
          width="36.2"
          height="18.51"
          style={{ fill: "#eee4f9", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="38.13"
          y="428.01"
          width="36.2"
          height="18.51"
          style={{ fill: "#eee4f9", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="37.91"
          y="479.42"
          width="36.2"
          height="18.51"
          style={{ fill: "#eee4f9", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="357.34"
          y="114.57"
          width="36.2"
          height="18.51"
          style={{ fill: "#eee4f9", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="359.11"
          y="163.97"
          width="36.2"
          height="18.51"
          style={{ fill: "#eee4f9", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="358.22"
          y="218.27"
          width="36.2"
          height="18.51"
          style={{ fill: "#eee4f9", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x={357}
          y="269.68"
          width="36.2"
          height="18.51"
          style={{ fill: "#eee4f9", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="357.28"
          y="321.59"
          width="36.2"
          height="18.51"
          style={{ fill: "#eee4f9", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="357.06"
          y={375}
          width="36.2"
          height="18.51"
          style={{ fill: "#eee4f9", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="357.17"
          y="428.3"
          width="36.2"
          height="18.51"
          style={{ fill: "#eee4f9", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="356.94"
          y="479.7"
          width="36.2"
          height="18.51"
          style={{ fill: "#eee4f9", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="315.25"
          y="403.91"
          width="13.64"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="257.47"
          y="560.93"
          width="29.55"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="257.55"
          y="612.48"
          width="29.55"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="257.55"
          y="665.48"
          width="29.55"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="351.51"
          y="560.21"
          width="29.55"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="351.6"
          y="611.75"
          width="29.55"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="351.6"
          y="664.75"
          width="29.55"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="201.55"
          y="612.98"
          width="29.55"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="201.55"
          y="665.98"
          width="29.55"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="156.55"
          y="612.98"
          width="29.55"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="156.55"
          y="665.98"
          width="29.55"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="80.55"
          y="612.98"
          width="29.55"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="80.55"
          y="665.98"
          width="29.55"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="39.55"
          y="612.98"
          width="29.55"
          height="41.43"
          style={{ fill: "none", stroke: "#ebdaf2", strokeMiterlimit: 10 }}
        />
        <rect
          x="39.55"
          y="665.98"
          width="29.55"
          height="41.43"
          style={{ fill: "none", stroke: "#ebdaf2", strokeMiterlimit: 10 }}
        />
        <rect
          x="243.5"
          y="511.63"
          width="13.64"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="275.89"
          y="511.89"
          width="13.64"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="315.91"
          y="511.78"
          width="13.64"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="358.91"
          y="511.78"
          width="24.41"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x={243}
          y="535.44"
          width="152.59"
          height="18.51"
          style={{ fill: "#eee4f9", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="39.34"
          y="510.2"
          width="29.55"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="36.05"
          y="533.05"
          width="36.2"
          height="18.51"
          style={{ fill: "#eee4f9", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="39.52"
          y="561.17"
          width="29.55"
          height="41.43"
          style={{ fill: "none", stroke: "#eee4f9", strokeMiterlimit: 10 }}
        />
        <rect
          x="36.23"
          y="585.03"
          width="36.2"
          height="18.51"
          style={{ fill: "#eee4f9" }}
        />
        <rect
          x="187.5"
          y="91.02"
          width="29.55"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="187.92"
          y="194.24"
          width="29.55"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="187.92"
          y="245.89"
          width="29.55"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="187.92"
          y="300.33"
          width="29.55"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="187.17"
          y="351.28"
          width="29.55"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="187.17"
          y="404.93"
          width="29.55"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="187.17"
          y="456.37"
          width="29.55"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="185.31"
          y={510}
          width="29.55"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="188.49"
          y="559.98"
          width="29.55"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="135.9"
          y="0.5"
          width="121.1"
          height="25.83"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="187.47"
          y="140.67"
          width="29.55"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="1.14"
          y="110.51"
          width="18.29"
          height="18.51"
          style={{ fill: "#eee4f9", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="0.63"
          y="163.51"
          width="18.29"
          height="18.51"
          style={{ fill: "#eee4f9", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="0.63"
          y="216.51"
          width="18.29"
          height="18.51"
          style={{ fill: "#eee4f9", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="0.63"
          y="269.07"
          width="18.29"
          height="18.51"
          style={{ fill: "#eee4f9", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="0.57"
          y="321.42"
          width="18.29"
          height="18.51"
          style={{ fill: "#eee4f9", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="0.57"
          y="374.03"
          width="18.29"
          height="18.51"
          style={{ fill: "#eee4f9", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="0.57"
          y="428.07"
          width="18.29"
          height="18.51"
          style={{ fill: "#eee4f9", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="0.5"
          y="479.59"
          width="18.29"
          height="18.51"
          style={{ fill: "#eee4f9", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="315.59"
          y="560.2"
          width="13.64"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="315.59"
          y="612.2"
          width="13.64"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="315.59"
          y="665.54"
          width="13.64"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="171.14"
          y="114.82"
          width="49.86"
          height="18.51"
          style={{ fill: "#eee4f9", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="170.83"
          y="164.22"
          width="49.86"
          height="18.51"
          style={{ fill: "#eee4f9", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="170.99"
          y="218.52"
          width="49.86"
          height="18.51"
          style={{ fill: "#eee4f9", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="170.68"
          y="269.93"
          width="49.86"
          height="18.51"
          style={{ fill: "#eee4f9", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="171.06"
          y="323.84"
          width="49.86"
          height="18.51"
          style={{ fill: "#eee4f9", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="170.75"
          y="374.25"
          width="49.86"
          height="18.51"
          style={{ fill: "#eee4f9", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="170.91"
          y="428.54"
          width="49.86"
          height="18.51"
          style={{ fill: "#eee4f9", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="170.6"
          y="479.95"
          width="49.86"
          height="18.51"
          style={{ fill: "#eee4f9", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="170.99"
          y="533.35"
          width="49.86"
          height="18.51"
          style={{ fill: "#eee4f9", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="170.68"
          y="582.75"
          width="49.86"
          height="18.51"
          style={{ fill: "#eee4f9", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="312.31"
          y="584.14"
          width="20.69"
          height="18.51"
          style={{ fill: "#eee4f9", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="347.89"
          y="584.14"
          width="37.11"
          height="18.51"
          style={{ fill: "#eee4f9", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
      </g>
    </svg>
  )
})

export const D4 = forwardRef((props, ref) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      height="100%"
      // height="100%"
      viewBox="0 0 544.35 1009.52"
    >
      <g id="elevation_d4">
        <rect
          x="65.69"
          y="50.5"
          width="386.83"
          height="956.73"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
          strokeWidth="3.05"
        />
        <rect
          x="121.16"
          y="17.23"
          width="115.35"
          height="35"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="81.48"
          y="121.23"
          width="37.04"
          height="38"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="80.72"
          y="172.23"
          width="37.04"
          height="41"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="80.72"
          y="224.23"
          width="37.04"
          height="41"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="81.15"
          y="277.96"
          width="37.04"
          height="41"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="81.15"
          y="329.96"
          width="37.04"
          height="41"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="82.72"
          y="383.27"
          width="37.04"
          height="41"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="82.72"
          y="435.27"
          width="37.04"
          height="41"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="83.14"
          y="489.01"
          width="37.04"
          height="41"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="83.14"
          y="541.01"
          width="37.04"
          height="41"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="85.72"
          y="593.14"
          width="37.04"
          height="41"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="85.72"
          y="645.14"
          width="37.04"
          height="41"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="86.14"
          y="698.88"
          width="37.04"
          height="41"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="86.14"
          y="750.88"
          width="37.04"
          height="41"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="128.68"
          y="121.66"
          width="29.84"
          height="37.57"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="167.53"
          y="121.68"
          width="29.84"
          height="37.57"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="129.1"
          y="173.67"
          width="29.84"
          height="37.57"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="167.96"
          y="173.69"
          width="29.84"
          height="37.57"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="128.89"
          y="223.73"
          width="29.84"
          height="39.5"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="167.74"
          y="223.75"
          width="29.84"
          height="39.5"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="129.32"
          y="277.73"
          width="29.84"
          height="39.52"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="168.17"
          y="277.75"
          width="29.84"
          height="39.52"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="129.78"
          y="329.73"
          width="29.84"
          height="41.5"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="168.64"
          y="329.75"
          width="29.84"
          height="41.5"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="130.21"
          y="383.73"
          width="29.84"
          height="39.51"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="169.06"
          y="383.75"
          width="29.84"
          height="39.51"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="130"
          y="435.73"
          width="29.84"
          height="40.51"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="168.85"
          y="435.75"
          width="29.84"
          height="40.51"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="130.42"
          y="488.73"
          width="29.84"
          height="39.52"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="169.28"
          y="488.75"
          width="29.84"
          height="39.52"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="129.78"
          y="540.73"
          width="29.84"
          height="40.98"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="168.64"
          y="540.75"
          width="29.84"
          height="40.98"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="130.21"
          y="593.69"
          width="29.84"
          height="40.02"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="169.06"
          y="593.71"
          width="29.84"
          height="40.02"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="130"
          y="644.6"
          width="29.84"
          height="41.11"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="168.85"
          y="644.62"
          width="29.84"
          height="41.11"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="130.42"
          y="697.56"
          width="29.84"
          height="42.14"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="169.28"
          y="697.58"
          width="29.84"
          height="42.14"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="130.1"
          y="751.21"
          width="29.84"
          height="40.5"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="168.96"
          y="751.23"
          width="29.84"
          height="40.5"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="86.53"
          y="803.13"
          width="29.84"
          height="40.5"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="134.53"
          y="803.65"
          width="57.98"
          height="40.5"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="86.46"
          y="856.39"
          width="29.84"
          height="40.5"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="134.46"
          y="856.91"
          width="57.98"
          height="40.5"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="86.49"
          y="907.37"
          width="29.84"
          height="40.5"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="134.49"
          y="907.89"
          width="57.98"
          height="40.5"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="86.42"
          y="960.63"
          width="29.84"
          height="40.5"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="134.42"
          y="961.15"
          width="57.98"
          height="40.5"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="212.58"
          y="802.51"
          width="29.84"
          height="40.5"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="212.51"
          y="855.77"
          width="29.84"
          height="40.5"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="212.55"
          y="906.75"
          width="29.84"
          height="40.5"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="212.48"
          y="960.01"
          width="29.84"
          height="40.5"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="257.46"
          y="907.26"
          width="52.06"
          height="40.5"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="257.42"
          y="960.26"
          width="52.06"
          height="40.5"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="257.44"
          y="802.76"
          width="52.06"
          height="40.5"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="257.4"
          y="855.76"
          width="52.06"
          height="40.5"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="212.69"
          y="749.31"
          width="29.84"
          height="40.5"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="257.54"
          y="749.56"
          width="52.06"
          height="40.5"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="257.08"
          y="645.88"
          width="52.06"
          height="40.5"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="257.05"
          y="698.88"
          width="52.06"
          height="40.5"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="257.19"
          y="592.68"
          width="52.06"
          height="40.5"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="257.08"
          y="488.62"
          width="52.06"
          height="40.5"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="257.05"
          y="541.62"
          width="52.06"
          height="40.5"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="257.19"
          y="435.42"
          width="52.06"
          height="40.5"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="257.08"
          y="330.54"
          width="52.06"
          height="40.5"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="257.05"
          y="383.54"
          width="52.06"
          height="40.5"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="257.19"
          y="277.33"
          width="52.06"
          height="40.5"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="258.08"
          y="169.8"
          width="52.06"
          height="40.5"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="258.05"
          y="222.8"
          width="52.06"
          height="40.5"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="258.19"
          y="116.59"
          width="52.06"
          height="40.5"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="219.01"
          y="121.57"
          width="22.6"
          height="37.57"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="219.34"
          y="173.58"
          width="22.6"
          height="37.57"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="219.18"
          y="223.64"
          width="22.6"
          height="39.5"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="219.5"
          y="277.64"
          width="22.6"
          height="39.52"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="219.85"
          y="329.64"
          width="22.6"
          height="41.5"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="220.18"
          y="383.64"
          width="22.6"
          height="39.51"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="220.01"
          y="435.64"
          width="22.6"
          height="40.51"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="220.34"
          y="488.64"
          width="22.6"
          height="39.52"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="219.85"
          y="540.64"
          width="22.6"
          height="40.98"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="220.18"
          y="593.6"
          width="22.6"
          height="40.02"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="220.01"
          y="644.51"
          width="22.6"
          height="41.11"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="220.34"
          y="697.47"
          width="22.6"
          height="42.14"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="376.52"
          y="802.43"
          width="66.54"
          height="40.5"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="376.65"
          y="749.23"
          width="66.54"
          height="40.5"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="376.06"
          y="645.55"
          width="66.54"
          height="40.5"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="376.01"
          y="698.55"
          width="66.54"
          height="40.5"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="376.19"
          y="592.35"
          width="66.54"
          height="40.5"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="376.06"
          y="488.29"
          width="66.54"
          height="40.5"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="376.01"
          y="541.29"
          width="66.54"
          height="40.5"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="376.19"
          y="435.09"
          width="66.54"
          height="40.5"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="376.06"
          y="330.2"
          width="66.54"
          height="40.5"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="376.01"
          y="383.2"
          width="66.54"
          height="40.5"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="376.19"
          y="277"
          width="66.54"
          height="40.5"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="377.34"
          y="169.47"
          width="66.54"
          height="40.5"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="377.29"
          y="222.47"
          width="66.54"
          height="40.5"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="377.47"
          y="116.26"
          width="66.54"
          height="40.5"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="331.18"
          y="172.57"
          width="15.9"
          height="37.57"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="331.41"
          y="225.58"
          width="15.9"
          height="37.57"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="331.3"
          y="277.64"
          width="15.9"
          height="39.5"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="331.52"
          y="331.64"
          width="15.9"
          height="39.52"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="331.77"
          y="382.64"
          width="15.9"
          height="41.5"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="332"
          y="436.64"
          width="15.9"
          height="39.51"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="331.89"
          y="488.64"
          width="15.9"
          height="40.51"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="332.11"
          y="542.64"
          width="15.9"
          height="39.52"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="331.77"
          y="592.64"
          width="15.9"
          height="40.98"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="332"
          y="646.6"
          width="15.9"
          height="40.02"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="331.89"
          y="698.51"
          width="15.9"
          height="41.11"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="332.11"
          y="749.47"
          width="15.9"
          height="42.14"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="332.19"
          y="119.68"
          width="15.9"
          height="37.57"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="334.73"
          y="802.9"
          width="15.9"
          height="41.11"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="334.96"
          y="853.86"
          width="15.9"
          height="42.14"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="335.3"
          y="906.04"
          width="15.9"
          height="41.11"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="335.53"
          y="960"
          width="15.9"
          height="42.14"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="376.63"
          y="910.4"
          width="66.54"
          height="40.5"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="376.77"
          y="857.2"
          width="66.54"
          height="40.5"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="376.7"
          y="961.8"
          width="66.54"
          height="40.5"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect x="63.96" y="949.73" width="425.33" height="5" fill="#eee4f9" />
        <rect x="64.96" y="899.73" width="425.33" height="5" fill="#eee4f9" />
        <rect x="63.96" y="846.73" width="425.33" height="5" fill="#eee4f9" />
        <rect x="63.75" y="793.55" width="425.33" height="5" fill="#eee4f9" />
        <rect x="63.96" y="741.73" width="425.33" height="5" fill="#eee4f9" />
        <rect x="63.97" y="690.73" width="425.33" height="5" fill="#eee4f9" />
        <rect x="63.26" y="636.23" width="425.33" height="5" fill="#eee4f9" />
        <rect x="64.26" y="586.23" width="425.33" height="5" fill="#eee4f9" />
        <rect x="63.26" y="533.23" width="425.33" height="5" fill="#eee4f9" />
        <rect x="63.05" y="480.05" width="425.33" height="5" fill="#eee4f9" />
        <rect x="63.26" y="428.23" width="425.33" height="5" fill="#eee4f9" />
        <rect x="63.26" y="377.23" width="425.33" height="5" fill="#eee4f9" />
        <rect x="63.26" y="322.31" width="425.33" height="5" fill="#eee4f9" />
        <rect x="64.26" y="272.31" width="425.33" height="5" fill="#eee4f9" />
        <rect x="63.26" y="219.31" width="425.33" height="5" fill="#eee4f9" />
        <rect x="63.05" y="166.14" width="425.33" height="5" fill="#eee4f9" />
        <rect x="63.26" y="114.31" width="425.33" height="5" fill="#eee4f9" />
        <rect x="62.95" y="44" width="425.33" height="14" fill="#eee4f9" />
        <rect x="109.02" y="54.38" width="6" height="111.81" fill="#eee4f9" />
        <rect x="150.97" y="54.38" width="6" height="111.81" fill="#eee4f9" />
        <rect x="192.97" y="54.38" width="6" height="111.81" fill="#eee4f9" />
        <rect x="233.97" y="54.38" width="6" height="111.81" fill="#eee4f9" />
        <rect x="271.97" y="54.38" width="6" height="111.81" fill="#eee4f9" />
        <rect x="310.94" y="54.38" width="6" height="111.81" fill="#eee4f9" />
        <rect x="352.82" y="52" width="6" height="116.73" fill="#eee4f9" />
        <rect x="394.82" y="52" width="6" height="116.73" fill="#eee4f9" />
        <rect x="435.82" y="52" width="6" height="116.73" fill="#eee4f9" />
        <rect x="479.01" y="56" width="6" height="953.52" fill="#eee4f9" />
        <rect x="90.92" y="169.6" width="6" height="51.94" fill="#eee4f9" />
        <rect x="132.87" y="169.6" width="6" height="51.94" fill="#eee4f9" />
        <rect x="174.87" y="169.6" width="6" height="51.94" fill="#eee4f9" />
        <rect x="215.87" y="169.6" width="6" height="51.94" fill="#eee4f9" />
        <rect x="253.87" y="169.6" width="6" height="51.94" fill="#eee4f9" />
        <rect x="292.84" y="169.6" width="6" height="51.94" fill="#eee4f9" />
        <rect x="334.72" y="168.5" width="6" height="54.23" fill="#eee4f9" />
        <rect x="376.72" y="168.5" width="6" height="54.23" fill="#eee4f9" />
        <rect x="417.72" y="168.5" width="6" height="54.23" fill="#eee4f9" />
        <rect x="455.72" y="168.5" width="6" height="54.23" fill="#eee4f9" />
        <rect x="99.01" y="222.26" width="6" height="51.94" fill="#eee4f9" />
        <rect x="140.96" y="222.26" width="6" height="51.94" fill="#eee4f9" />
        <rect x="182.96" y="222.26" width="6" height="51.94" fill="#eee4f9" />
        <rect x="223.96" y="222.26" width="6" height="51.94" fill="#eee4f9" />
        <rect x="261.96" y="222.26" width="6" height="51.94" fill="#eee4f9" />
        <rect x="300.93" y="222.26" width="6" height="51.94" fill="#eee4f9" />
        <rect x="342.81" y="221.16" width="6" height="54.23" fill="#eee4f9" />
        <rect x="384.81" y="221.16" width="6" height="54.23" fill="#eee4f9" />
        <rect x="425.81" y="221.16" width="6" height="54.23" fill="#eee4f9" />
        <rect x="463.81" y="221.16" width="6" height="54.23" fill="#eee4f9" />
        <rect x="95.01" y="272.82" width="6" height="51.94" fill="#eee4f9" />
        <rect x="136.96" y="272.82" width="6" height="51.94" fill="#eee4f9" />
        <rect x="178.96" y="272.82" width="6" height="51.94" fill="#eee4f9" />
        <rect x="219.96" y="272.82" width="6" height="51.94" fill="#eee4f9" />
        <rect x="257.96" y="272.82" width="6" height="51.94" fill="#eee4f9" />
        <rect x="296.93" y="272.82" width="6" height="51.94" fill="#eee4f9" />
        <rect x="338.81" y="271.72" width="6" height="54.23" fill="#eee4f9" />
        <rect x="380.81" y="271.72" width="6" height="54.23" fill="#eee4f9" />
        <rect x="421.81" y="271.72" width="6" height="54.23" fill="#eee4f9" />
        <rect x="459.81" y="271.72" width="6" height="54.23" fill="#eee4f9" />
        <rect x="90.01" y="325.82" width="6" height="51.94" fill="#eee4f9" />
        <rect x="131.96" y="325.82" width="6" height="51.94" fill="#eee4f9" />
        <rect x="173.96" y="325.82" width="6" height="51.94" fill="#eee4f9" />
        <rect x="214.96" y="325.82" width="6" height="51.94" fill="#eee4f9" />
        <rect x="252.96" y="325.82" width="6" height="51.94" fill="#eee4f9" />
        <rect x="291.93" y="325.82" width="6" height="51.94" fill="#eee4f9" />
        <rect x="333.81" y="324.72" width="6" height="54.23" fill="#eee4f9" />
        <rect x="375.81" y="324.72" width="6" height="54.23" fill="#eee4f9" />
        <rect x="416.81" y="324.72" width="6" height="54.23" fill="#eee4f9" />
        <rect x="454.81" y="324.72" width="6" height="54.23" fill="#eee4f9" />
        <rect x="79.01" y="380.35" width="6" height="51.94" fill="#eee4f9" />
        <rect x="120.96" y="380.35" width="6" height="51.94" fill="#eee4f9" />
        <rect x="162.96" y="380.35" width="6" height="51.94" fill="#eee4f9" />
        <rect x="203.96" y="380.35" width="6" height="51.94" fill="#eee4f9" />
        <rect x="241.96" y="380.35" width="6" height="51.94" fill="#eee4f9" />
        <rect x="280.93" y="380.35" width="6" height="51.94" fill="#eee4f9" />
        <rect x="322.81" y="379.24" width="6" height="54.23" fill="#eee4f9" />
        <rect x="364.81" y="379.24" width="6" height="54.23" fill="#eee4f9" />
        <rect x="405.81" y="379.24" width="6" height="54.23" fill="#eee4f9" />
        <rect x="443.81" y="379.24" width="6" height="54.23" fill="#eee4f9" />
        <rect x="107.01" y="429.91" width="6" height="51.94" fill="#eee4f9" />
        <rect x="148.96" y="429.91" width="6" height="51.94" fill="#eee4f9" />
        <rect x="190.96" y="429.91" width="6" height="51.94" fill="#eee4f9" />
        <rect x="231.96" y="429.91" width="6" height="51.94" fill="#eee4f9" />
        <rect x="269.96" y="429.91" width="6" height="51.94" fill="#eee4f9" />
        <rect x="308.93" y="429.91" width="6" height="51.94" fill="#eee4f9" />
        <rect x="350.81" y="428.81" width="6" height="54.23" fill="#eee4f9" />
        <rect x="392.81" y="428.81" width="6" height="54.23" fill="#eee4f9" />
        <rect x="433.81" y="428.81" width="6" height="54.23" fill="#eee4f9" />
        <rect x="113.01" y="481.65" width="6" height="51.94" fill="#eee4f9" />
        <rect x="154.96" y="481.65" width="6" height="51.94" fill="#eee4f9" />
        <rect x="196.96" y="481.65" width="6" height="51.94" fill="#eee4f9" />
        <rect x="237.96" y="481.65" width="6" height="51.94" fill="#eee4f9" />
        <rect x="275.96" y="481.65" width="6" height="51.94" fill="#eee4f9" />
        <rect x="314.93" y="481.65" width="6" height="51.94" fill="#eee4f9" />
        <rect x="356.81" y="480.55" width="6" height="54.23" fill="#eee4f9" />
        <rect x="398.81" y="480.55" width="6" height="54.23" fill="#eee4f9" />
        <rect x="439.81" y="480.55" width="6" height="54.23" fill="#eee4f9" />
        <rect x="477.81" y="480.55" width="6" height="54.23" fill="#eee4f9" />
        <rect x="105.01" y="536.61" width="6" height="51.94" fill="#eee4f9" />
        <rect x="146.96" y="536.61" width="6" height="51.94" fill="#eee4f9" />
        <rect x="188.96" y="536.61" width="6" height="51.94" fill="#eee4f9" />
        <rect x="229.96" y="536.61" width="6" height="51.94" fill="#eee4f9" />
        <rect x="267.96" y="536.61" width="6" height="51.94" fill="#eee4f9" />
        <rect x="306.93" y="536.61" width="6" height="51.94" fill="#eee4f9" />
        <rect x="348.81" y="535.5" width="6" height="54.23" fill="#eee4f9" />
        <rect x="390.81" y="535.5" width="6" height="54.23" fill="#eee4f9" />
        <rect x="431.81" y="535.5" width="6" height="54.23" fill="#eee4f9" />
        <rect x="92.01" y="589.61" width="6" height="51.94" fill="#eee4f9" />
        <rect x="133.96" y="589.61" width="6" height="51.94" fill="#eee4f9" />
        <rect x="175.96" y="589.61" width="6" height="51.94" fill="#eee4f9" />
        <rect x="216.96" y="589.61" width="6" height="51.94" fill="#eee4f9" />
        <rect x="254.96" y="589.61" width="6" height="51.94" fill="#eee4f9" />
        <rect x="293.93" y="589.61" width="6" height="51.94" fill="#eee4f9" />
        <rect x="335.81" y="588.5" width="6" height="54.23" fill="#eee4f9" />
        <rect x="377.81" y="588.5" width="6" height="54.23" fill="#eee4f9" />
        <rect x="418.81" y="588.5" width="6" height="54.23" fill="#eee4f9" />
        <rect x="456.81" y="588.5" width="6" height="54.23" fill="#eee4f9" />
        <rect x="76.01" y="639.56" width="6" height="51.94" fill="#eee4f9" />
        <rect x="117.96" y="639.56" width="6" height="51.94" fill="#eee4f9" />
        <rect x="159.96" y="639.56" width="6" height="51.94" fill="#eee4f9" />
        <rect x="200.96" y="639.56" width="6" height="51.94" fill="#eee4f9" />
        <rect x="238.96" y="639.56" width="6" height="51.94" fill="#eee4f9" />
        <rect x="277.93" y="639.56" width="6" height="51.94" fill="#eee4f9" />
        <rect x="319.81" y="638.46" width="6" height="54.23" fill="#eee4f9" />
        <rect x="361.81" y="638.46" width="6" height="54.23" fill="#eee4f9" />
        <rect x="402.81" y="638.46" width="6" height="54.23" fill="#eee4f9" />
        <rect x="440.81" y="638.46" width="6" height="54.23" fill="#eee4f9" />
        <rect x="109.01" y="695.08" width="6" height="51.94" fill="#eee4f9" />
        <rect x="150.96" y="695.08" width="6" height="51.94" fill="#eee4f9" />
        <rect x="192.96" y="695.08" width="6" height="51.94" fill="#eee4f9" />
        <rect x="233.96" y="695.08" width="6" height="51.94" fill="#eee4f9" />
        <rect x="271.96" y="695.08" width="6" height="51.94" fill="#eee4f9" />
        <rect x="310.93" y="695.08" width="6" height="51.94" fill="#eee4f9" />
        <rect x="352.81" y="693.98" width="6" height="54.23" fill="#eee4f9" />
        <rect x="394.81" y="693.98" width="6" height="54.23" fill="#eee4f9" />
        <rect x="435.81" y="693.98" width="6" height="54.23" fill="#eee4f9" />
        <rect x="99.01" y="745.04" width="6" height="51.94" fill="#eee4f9" />
        <rect x="140.96" y="745.04" width="6" height="51.94" fill="#eee4f9" />
        <rect x="182.96" y="745.04" width="6" height="51.94" fill="#eee4f9" />
        <rect x="223.96" y="745.04" width="6" height="51.94" fill="#eee4f9" />
        <rect x="261.96" y="745.04" width="6" height="51.94" fill="#eee4f9" />
        <rect x="300.93" y="745.04" width="6" height="51.94" fill="#eee4f9" />
        <rect x="342.81" y="743.94" width="6" height="54.23" fill="#eee4f9" />
        <rect x="384.81" y="743.94" width="6" height="54.23" fill="#eee4f9" />
        <rect x="425.81" y="743.94" width="6" height="54.23" fill="#eee4f9" />
        <rect x="463.81" y="743.94" width="6" height="54.23" fill="#eee4f9" />
        <rect x="87.01" y="797.39" width="6" height="51.94" fill="#eee4f9" />
        <rect x="128.96" y="797.39" width="6" height="51.94" fill="#eee4f9" />
        <rect x="170.96" y="797.39" width="6" height="51.94" fill="#eee4f9" />
        <rect x="211.96" y="797.39" width="6" height="51.94" fill="#eee4f9" />
        <rect x="249.96" y="797.39" width="6" height="51.94" fill="#eee4f9" />
        <rect x="288.93" y="797.39" width="6" height="51.94" fill="#eee4f9" />
        <rect x="330.81" y="796.29" width="6" height="54.23" fill="#eee4f9" />
        <rect x="372.81" y="796.29" width="6" height="54.23" fill="#eee4f9" />
        <rect x="413.81" y="796.29" width="6" height="54.23" fill="#eee4f9" />
        <rect x="451.81" y="796.29" width="6" height="54.23" fill="#eee4f9" />
        <rect x="77.01" y="846.39" width="6" height="51.94" fill="#eee4f9" />
        <rect x="118.96" y="846.39" width="6" height="51.94" fill="#eee4f9" />
        <rect x="160.96" y="846.39" width="6" height="51.94" fill="#eee4f9" />
        <rect x="201.96" y="846.39" width="6" height="51.94" fill="#eee4f9" />
        <rect x="239.96" y="846.39" width="6" height="51.94" fill="#eee4f9" />
        <rect x="278.93" y="846.39" width="6" height="51.94" fill="#eee4f9" />
        <rect x="320.81" y="845.29" width="6" height="54.23" fill="#eee4f9" />
        <rect x="362.81" y="845.29" width="6" height="54.23" fill="#eee4f9" />
        <rect x="403.81" y="845.29" width="6" height="54.23" fill="#eee4f9" />
        <rect x="441.81" y="845.29" width="6" height="54.23" fill="#eee4f9" />
        <rect x="83.01" y="901.35" width="6" height="51.94" fill="#eee4f9" />
        <rect x="124.96" y="901.35" width="6" height="51.94" fill="#eee4f9" />
        <rect x="166.96" y="901.35" width="6" height="51.94" fill="#eee4f9" />
        <rect x="207.96" y="901.35" width="6" height="51.94" fill="#eee4f9" />
        <rect x="245.96" y="901.35" width="6" height="51.94" fill="#eee4f9" />
        <rect x="284.93" y="901.35" width="6" height="51.94" fill="#eee4f9" />
        <rect x="326.81" y="900.24" width="6" height="54.23" fill="#eee4f9" />
        <rect x="368.81" y="900.24" width="6" height="54.23" fill="#eee4f9" />
        <rect x="409.81" y="900.24" width="6" height="54.23" fill="#eee4f9" />
        <rect x="447.81" y="900.24" width="6" height="54.23" fill="#eee4f9" />
        <rect x="74.01" y="951.3" width="6" height="51.94" fill="#eee4f9" />
        <rect x="115.96" y="951.3" width="6" height="51.94" fill="#eee4f9" />
        <rect x="157.96" y="951.3" width="6" height="51.94" fill="#eee4f9" />
        <rect x="198.96" y="951.3" width="6" height="51.94" fill="#eee4f9" />
        <rect x="236.96" y="951.3" width="6" height="51.94" fill="#eee4f9" />
        <rect x="275.93" y="951.3" width="6" height="51.94" fill="#eee4f9" />
        <rect x="317.81" y="950.2" width="6" height="54.23" fill="#eee4f9" />
        <rect x="359.81" y="950.2" width="6" height="54.23" fill="#eee4f9" />
        <rect x="400.81" y="950.2" width="6" height="54.23" fill="#eee4f9" />
        <rect x="438.81" y="950.2" width="6" height="54.23" fill="#eee4f9" />
        <rect x="68.01" y="57.73" width="8" height="951.79" fill="#eee4f9" />
        <rect
          x="80.87"
          y="62.62"
          width="37.04"
          height="38"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="128.07"
          y="63.06"
          width="29.84"
          height="37.57"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="166.93"
          y="63.08"
          width="29.84"
          height="37.57"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="257.58"
          y="57.99"
          width="52.06"
          height="40.5"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="218.41"
          y="62.97"
          width="22.6"
          height="37.57"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="376.87"
          y="57.66"
          width="66.54"
          height="40.5"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="331.59"
          y="61.08"
          width="15.9"
          height="37.57"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
      </g>
      <g id="interactive_floors">
        <rect
          id="floor_button_0"
          x="65.08"
          y="955.5"
          width="385.52"
          height="51"
          fill="none"
        />
        <rect
          id="floor_button_1"
          x="64.09"
          y="903.5"
          width="385.52"
          height="51"
          fill="none"
        />
        <rect
          id="floor_button_2"
          x="66.07"
          y="851.5"
          width="385.52"
          height="51"
          fill="none"
        />
        <rect
          id="floor_button_3"
          x="66.07"
          y="798.5"
          width="385.52"
          height="52"
          fill="none"
        />
        <rect
          id="floor_button_4"
          x="64.09"
          y="746.5"
          width="385.52"
          height="51"
          fill="none"
        />
        <rect
          id="floor_button_5"
          x="64.09"
          y="693.5"
          width="385.52"
          height="53"
          fill="none"
        />
        <rect
          id="floor_button_6"
          x="64.09"
          y="641.5"
          width="385.52"
          height="52"
          fill="none"
        />
        <rect
          id="floor_button_7"
          x="64.09"
          y="588.5"
          width="385.52"
          height="52"
          fill="none"
        />
        <rect
          id="floor_button_8"
          x="64.09"
          y="536.5"
          width="385.52"
          height="52"
          fill="none"
        />
        <rect
          id="floor_button_9"
          x="64.09"
          y="484.5"
          width="385.52"
          height="52"
          fill="none"
        />
        <rect
          id="floor_button_10"
          x="64.09"
          y="432.5"
          width="385.52"
          height="52"
          fill="none"
        />
        <rect
          id="floor_button_11"
          x="64.09"
          y="379.5"
          width="385.52"
          height="52"
          fill="none"
        />
        <rect
          id="floor_button_12"
          x="64.09"
          y="326.5"
          width="385.52"
          height="52"
          fill="none"
        />
        <rect
          id="floor_button_13"
          x="64.09"
          y="273.5"
          width="385.52"
          height="52"
          fill="none"
        />
        <rect
          id="floor_button_14"
          x="64.09"
          y="220.5"
          width="385.52"
          height="52"
          fill="none"
        />
        <rect
          id="floor_button_15"
          x="64.09"
          y="167.5"
          width="385.52"
          height="52"
          fill="none"
        />
        <rect
          id="floor_button_17"
          x="65.45"
          y="57"
          width="387.14"
          height="53"
          fill="none"
        />
        <rect
          id="floor_button_16"
          x="64.09"
          y="114.5"
          width="388.5"
          height="52"
          fill="none"
        />
        <rect
          id="floor_circle_3"
          y="806.58"
          width="37.82"
          height="37.82"
          rx="18.91"
          fill="#bdb3b7"
        />
        <text
          id="floor_no_3"
          transform="translate(11.89 833.83)"
          fontSize="24.31"
          fill="#fff"
          fontFamily="Lora-Regular, Lora"
        >
          3
        </text>
        <rect
          id="floor_circle_2"
          y="858.58"
          width="37.82"
          height="37.82"
          rx="18.91"
          fill="#bdb3b7"
        />
        <text
          id="floor_no_2"
          transform="translate(12.13 885.83)"
          fontSize="24.31"
          fill="#fff"
          fontFamily="Lora-Regular, Lora"
        >
          2
        </text>
        <rect
          id="floor_circle_1"
          y="910.58"
          width="37.82"
          height="37.82"
          rx="18.91"
          fill="#bdb3b7"
        />
        <text
          id="floor_no_1"
          transform="translate(14.24 937.83)"
          fontSize="24.31"
          fill="#fff"
          fontFamily="Lora-Regular, Lora"
        >
          1
        </text>
        <rect
          id="floor_circle_0"
          y="962.58"
          width="37.82"
          height="37.82"
          rx="18.91"
          fill="#bdb3b7"
        />
        <text
          id="floor_no_0"
          transform="translate(9.41 990.83)"
          fontSize="24.31"
          fill="#fff"
          fontFamily="Lora-Regular, Lora"
        >
          G
        </text>
        <rect
          id="floor_circle_4"
          y="754.58"
          width="37.82"
          height="37.82"
          rx="18.91"
          fill="#bdb3b7"
        />
        <text
          id="floor_no_4"
          transform="translate(12.07 781.83)"
          fontSize="24.31"
          fill="#fff"
          fontFamily="Lora-Regular, Lora"
        >
          4
        </text>
        <rect
          id="floor_circle_5"
          y="702.58"
          width="37.82"
          height="37.82"
          rx="18.91"
          fill="#bdb3b7"
        />
        <text
          id="floor_no_5"
          transform="translate(12.05 730.83)"
          fontSize="24.31"
          fill="#fff"
          fontFamily="Lora-Regular, Lora"
        >
          5
        </text>
        <rect
          id="floor_circle_9"
          x="0.2"
          y="490.35"
          width="37.82"
          height="37.82"
          rx="18.91"
          fill="#bdb3b7"
        />
        <text
          id="floor_no_9"
          transform="translate(11.83 518.61)"
          fontSize="24.31"
          fill="#fff"
          fontFamily="Lora-Regular, Lora"
        >
          9
        </text>
        <rect
          id="floor_circle_8"
          x="0.2"
          y="542.35"
          width="37.82"
          height="37.82"
          rx="18.91"
          fill="#bdb3b7"
        />
        <text
          id="floor_no_8"
          transform="translate(12.03 570.61)"
          fontSize="24.31"
          fill="#fff"
          fontFamily="Lora-Regular, Lora"
        >
          8
        </text>
        <rect
          id="floor_circle_7"
          x="0.2"
          y="594.35"
          width="37.82"
          height="37.82"
          rx="18.91"
          fill="#bdb3b7"
        />
        <text
          id="floor_no_7"
          transform="translate(13.26 622.61)"
          fontSize="24.31"
          fill="#fff"
          fontFamily="Lora-Regular, Lora"
        >
          7
        </text>
        <rect
          id="floor_circle_6"
          x="0.2"
          y="646.35"
          width="37.82"
          height="37.82"
          rx="18.91"
          fill="#bdb3b7"
        />
        <text
          id="floor_no_6"
          transform="translate(11.83 674.61)"
          fontSize="24.31"
          fill="#fff"
          fontFamily="Lora-Regular, Lora"
        >
          6
        </text>
        <rect
          id="floor_circle_10"
          x="0.2"
          y="438.35"
          width="37.82"
          height="37.82"
          rx="18.91"
          fill="#bdb3b7"
        />
        <text
          id="floor_no_10"
          transform="translate(6.89 466.61)"
          fontSize="24.31"
          fill="#fff"
          fontFamily="Lora-Regular, Lora"
        >
          10
        </text>
        <rect
          id="floor_circle_11"
          x="0.2"
          y="386.35"
          width="37.82"
          height="37.82"
          rx="18.91"
          fill="#bdb3b7"
        />
        <text
          id="floor_no_11"
          transform="translate(10.01 414.61)"
          fontSize="24.31"
          fill="#fff"
          fontFamily="Lora-Regular, Lora"
        >
          11
        </text>
        <rect
          id="floor_circle_12"
          x="0.99"
          y="331.33"
          width="37.82"
          height="37.82"
          rx="18.91"
          fill="#bdb3b7"
        />
        <text
          id="floor_no_12"
          transform="translate(8.7 359.59)"
          fontSize="24.31"
          fill="#fff"
          fontFamily="Lora-Regular, Lora"
        >
          12
        </text>
        <rect
          id="floor_circle_13"
          x="0.98"
          y="278.83"
          width="37.82"
          height="37.82"
          rx="18.91"
          fill="#bdb3b7"
        />
        <text
          id="floor_no_13"
          transform="translate(8.45 307.09)"
          fontSize="24.31"
          fill="#fff"
          fontFamily="Lora-Regular, Lora"
        >
          13
        </text>
        <rect
          id="floor_circle_14"
          x="0.86"
          y="225.83"
          width="37.82"
          height="37.82"
          rx="18.91"
          fill="#bdb3b7"
        />
        <text
          id="floor_no_14"
          transform="translate(8.51 254.09)"
          fontSize="24.31"
          fill="#fff"
          fontFamily="Lora-Regular, Lora"
        >
          14
        </text>
        <rect
          id="floor_circle_15"
          x="0.68"
          y="172.72"
          width="37.82"
          height="37.82"
          rx="18.91"
          fill="#bdb3b7"
        />
        <text
          id="floor_no_15"
          transform="translate(8.3 200.98)"
          fontSize="24.31"
          fill="#fff"
          fontFamily="Lora-Regular, Lora"
        >
          15
        </text>
        <rect
          id="floor_circle_16"
          x="0.21"
          y="118.89"
          width="37.82"
          height="37.82"
          rx="18.91"
          fill="#bdb3b7"
        />
        <text
          id="floor_no_16"
          transform="translate(7.42 147.14)"
          fontSize="24.31"
          fill="#fff"
          fontFamily="Lora-Regular, Lora"
        >
          16
        </text>
        <rect
          id="apt_circle_3"
          x="506.35"
          y="804.68"
          width="37.82"
          height="37.82"
          rx="18.91"
          fill="#857695"
        />
        <text
          id="apt_no_3"
          transform="translate(514.06 832.93)"
          fontSize="24.31"
          fill="#fff"
          fontFamily="Lora-Regular, Lora"
        >
          12
        </text>
        <rect
          id="apt_circle_2"
          x="506.35"
          y="856.68"
          width="37.82"
          height="37.82"
          rx="18.91"
          fill="#857695"
        />
        <text
          id="apt_no_2"
          transform="translate(518.24 884.93)"
          fontSize="24.31"
          fill="#fff"
          fontFamily="Lora-Regular, Lora"
        >
          3
        </text>
        <rect
          id="apt_circle_1"
          x="506.35"
          y="908.68"
          width="37.82"
          height="37.82"
          rx="18.91"
          fill="#857695"
        />
        <text
          id="apt_no_1"
          transform="translate(518.24 936.93)"
          fontSize="24.31"
          fill="#fff"
          fontFamily="Lora-Regular, Lora"
        >
          3
        </text>
        <rect
          id="apt_circle_0"
          x="506.35"
          y="960.68"
          width="37.82"
          height="37.82"
          rx="18.91"
          fill="#857695"
        />
        <text
          id="apt_no_0"
          transform="translate(513.04 988.93)"
          fontSize="24.31"
          fill="#fff"
          fontFamily="Lora-Regular, Lora"
        >
          10
        </text>
        <rect
          id="apt_circle_4"
          x="506.35"
          y="752.68"
          width="37.82"
          height="37.82"
          rx="18.91"
          fill="#857695"
        />
        <text
          id="apt_no_4"
          transform="translate(511.83 779.93)"
          fontSize="24.31"
          fill="#fff"
          fontFamily="Lora-Regular, Lora"
        >
          44
        </text>
        <rect
          id="apt_circle_5"
          x="506.35"
          y="700.68"
          width="37.82"
          height="37.82"
          rx="18.91"
          fill="#857695"
        />
        <text
          id="apt_no_5"
          transform="translate(518.48 728.93)"
          fontSize="24.31"
          fill="#fff"
          fontFamily="Lora-Regular, Lora"
        >
          2
        </text>
        <rect
          id="apt_circle_6"
          x="506.15"
          y="646.34"
          width="37.82"
          height="37.82"
          rx="18.91"
          fill="#857695"
        />
        <text
          id="apt_no_6"
          transform="translate(518.29 674.6)"
          fontSize="24.31"
          fill="#fff"
          fontFamily="Lora-Regular, Lora"
        >
          2
        </text>
        <rect
          id="apt_circle_7"
          x="506.54"
          y="592.12"
          width="37.82"
          height="37.82"
          rx="18.91"
          fill="#857695"
        />
        <text
          id="apt_no_7"
          transform="translate(518.67 620.38)"
          fontSize="24.31"
          fill="#fff"
          fontFamily="Lora-Regular, Lora"
        >
          2
        </text>
        <rect
          id="apt_circle_8"
          x="506.2"
          y="538.4"
          width="37.82"
          height="37.82"
          rx="18.91"
          fill="#857695"
        />
        <text
          id="apt_no_8"
          transform="translate(518.34 566.66)"
          fontSize="24.31"
          fill="#fff"
          fontFamily="Lora-Regular, Lora"
        >
          2
        </text>
        <rect
          id="apt_circle_9"
          x="505.89"
          y="484.93"
          width="37.82"
          height="37.82"
          rx="18.91"
          fill="#857695"
        />
        <text
          id="apt_no_9"
          transform="translate(518.02 513.19)"
          fontSize="24.31"
          fill="#fff"
          fontFamily="Lora-Regular, Lora"
        >
          2
        </text>
        <rect
          id="apt_circle_10"
          x="506.25"
          y="429.01"
          width="37.82"
          height="37.82"
          rx="18.91"
          fill="#857695"
        />
        <text
          id="apt_no_10"
          transform="translate(518.39 457.27)"
          fontSize="24.31"
          fill="#fff"
          fontFamily="Lora-Regular, Lora"
        >
          2
        </text>
        <rect
          id="apt_circle_11"
          x="505.25"
          y="377.01"
          width="37.82"
          height="37.82"
          rx="18.91"
          fill="#857695"
        />
        <text
          id="apt_no_11"
          transform="translate(517.39 405.27)"
          fontSize="24.31"
          fill="#fff"
          fontFamily="Lora-Regular, Lora"
        >
          2
        </text>
        <rect
          id="apt_circle_12"
          x="505.07"
          y="324.97"
          width="37.82"
          height="37.82"
          rx="18.91"
          fill="#857695"
        />
        <text
          id="apt_no_12"
          transform="translate(517.21 353.23)"
          fontSize="24.31"
          fill="#fff"
          fontFamily="Lora-Regular, Lora"
        >
          2
        </text>
        <rect
          id="apt_circle_13"
          x="504.89"
          y="273.33"
          width="37.82"
          height="37.82"
          rx="18.91"
          fill="#857695"
        />
        <text
          id="apt_no_13"
          transform="translate(517.03 301.59)"
          fontSize="24.31"
          fill="#fff"
          fontFamily="Lora-Regular, Lora"
        >
          2
        </text>
        <rect
          id="apt_circle_14"
          x="504.89"
          y="221.33"
          width="37.82"
          height="37.82"
          rx="18.91"
          fill="#857695"
        />
        <text
          id="apt_no_14"
          transform="translate(517.03 249.59)"
          fontSize="24.31"
          fill="#fff"
          fontFamily="Lora-Regular, Lora"
        >
          2
        </text>
        <rect
          id="apt_circle_15"
          x="504.76"
          y="168.57"
          width="37.82"
          height="37.82"
          rx="18.91"
          fill="#857695"
        />
        <text
          id="apt_no_15"
          transform="translate(516.89 196.83)"
          fontSize="24.31"
          fill="#fff"
          fontFamily="Lora-Regular, Lora"
        >
          2
        </text>
        <rect
          id="apt_circle_16"
          x="503.9"
          y="115.38"
          width="37.82"
          height="37.82"
          rx="18.91"
          fill="#857695"
        />
        <text
          id="apt_no_16"
          transform="translate(516.03 142.63)"
          fontSize="24.31"
          fill="#fff"
          fontFamily="Lora-Regular, Lora"
        >
          2
        </text>
        <rect
          id="apt_circle_17"
          x="503.09"
          y="62.99"
          width="37.82"
          height="37.82"
          rx="18.91"
          fill="#857695"
        />
        <text
          id="apt_no_17"
          transform="translate(515.23 91.25)"
          fontSize="24.31"
          fill="#fff"
          fontFamily="Lora-Regular, Lora"
        >
          2
        </text>
        <rect
          id="floor_circle_17"
          x="0.99"
          y="65.1"
          width="37.82"
          height="37.82"
          rx="18.91"
          fill="#bdb3b7"
        />
        <text
          id="floor_no_17"
          transform="translate(9.62 93.36)"
          fontSize="24.31"
          fill="#fff"
          fontFamily="Lora-Regular, Lora"
        >
          17
        </text>
        <rect
          id="floor_button_t"
          x="64.78"
          width="387.14"
          height="53"
          fill="none"
        />
      </g>
    </svg>
  )
})
export const C1 = forwardRef((props, ref) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 498.88 594.29"
      width="100%"
      ref={ref}
      // height="594.29"
      {...props}
    >
      <g id="c1">
        <rect
          x="73.93"
          y="434.85"
          width="27.82"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="28.78"
          y="496.57"
          width="36.04"
          height="71.3"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="94.19"
          y="496.57"
          width="14.22"
          height="71.3"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="139.19"
          y="496.57"
          width="14.22"
          height="71.3"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="194.99"
          y="496.57"
          width="14.22"
          height="71.3"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="256.78"
          y="496.57"
          width="36.04"
          height="71.3"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="333.19"
          y="496.57"
          width="14.22"
          height="71.3"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="378.19"
          y="496.57"
          width="14.22"
          height="71.3"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="417.08"
          y="496.57"
          width="36.04"
          height="71.3"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="28.58"
          y="227.03"
          width="27.82"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="24.18"
          y="249.98"
          width="34.68"
          height="18.51"
          style={{ fill: "#eee4f9", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="37.86"
          y="173.03"
          width="27.82"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="33.46"
          y="195.98"
          width="34.68"
          height="18.51"
          style={{ fill: "#eee4f9", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="27.54"
          y="120.03"
          width="27.82"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="23.14"
          y="142.98"
          width="34.68"
          height="18.51"
          style={{ fill: "#eee4f9", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="37.56"
          y="70.01"
          width="27.82"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="33.15"
          y="92.96"
          width="34.68"
          height="18.51"
          style={{ fill: "#eee4f9", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="30.09"
          y="435.34"
          width="27.82"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="25.69"
          y="458.3"
          width="83.7"
          height="18.51"
          style={{ fill: "#eee4f9", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="39.37"
          y="381.34"
          width="27.82"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="34.96"
          y="404.3"
          width="34.68"
          height="18.51"
          style={{ fill: "#eee4f9", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="29.05"
          y="328.34"
          width="27.82"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="24.65"
          y="351.3"
          width="34.68"
          height="18.51"
          style={{ fill: "#eee4f9", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="40.06"
          y="280.33"
          width="27.82"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="35.66"
          y="303.28"
          width="34.68"
          height="18.51"
          style={{ fill: "#eee4f9", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="100.5"
          y="278.32"
          width="13.64"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="98.34"
          y="301.27"
          width={17}
          height="18.51"
          style={{ fill: "#eee4f9", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="89.5"
          y="227.32"
          width="13.64"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="87.34"
          y="250.27"
          width={17}
          height="18.51"
          style={{ fill: "#eee4f9", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="96.5"
          y="173.32"
          width="13.64"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="94.34"
          y="196.27"
          width={17}
          height="18.51"
          style={{ fill: "#eee4f9", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="88.5"
          y="120.32"
          width="13.64"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="86.34"
          y="143.27"
          width={17}
          height="18.51"
          style={{ fill: "#eee4f9", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="95.5"
          y="384.84"
          width="13.64"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="93.34"
          y="407.79"
          width={17}
          height="18.51"
          style={{ fill: "#eee4f9", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="87.5"
          y="331.84"
          width="13.64"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="85.34"
          y="354.79"
          width={17}
          height="18.51"
          style={{ fill: "#eee4f9", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="140.77"
          y="227.11"
          width="13.61"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="141.27"
          y="280.11"
          width="13.61"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="141.27"
          y="332.11"
          width="13.61"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="141.27"
          y="383.68"
          width="13.61"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="141.03"
          y="435.68"
          width="13.61"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="185.78"
          y="227.39"
          width="13.61"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="180.38"
          y="280.39"
          width="19.51"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="186.28"
          y="332.39"
          width="13.61"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="180.38"
          y="383.96"
          width="19.51"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="186.04"
          y="435.96"
          width="13.61"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="160.52"
          y="67.84"
          width="13.61"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="205.54"
          y="68.12"
          width="13.61"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="143.52"
          y="122.28"
          width="13.61"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="188.54"
          y="122.56"
          width="13.61"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="160.52"
          y="173.28"
          width="13.61"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="205.54"
          y="173.56"
          width="13.61"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="104.5"
          y="70.4"
          width="13.64"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="102.34"
          y="93.35"
          width={17}
          height="18.51"
          style={{ fill: "#eee4f9", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="332.02"
          y="67.56"
          width="13.61"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="377.04"
          y="67.84"
          width="13.61"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="315.02"
          y="121.99"
          width="13.61"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="360.04"
          y="122.28"
          width="13.61"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="332.02"
          y="172.99"
          width="13.61"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="377.04"
          y="173.28"
          width="13.61"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="314.89"
          y="226.91"
          width="13.61"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="359.91"
          y="227.19"
          width="13.61"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="331.89"
          y="277.91"
          width="13.61"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="376.91"
          y="278.19"
          width="13.61"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="314.89"
          y="333.86"
          width="13.61"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="359.91"
          y="334.14"
          width="13.61"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="331.89"
          y="384.86"
          width="13.61"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="376.91"
          y="385.14"
          width="13.61"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="309.39"
          y="435.88"
          width="13.61"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="354.41"
          y="436.17"
          width="13.61"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="246.09"
          y="226.08"
          width="27.82"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="241.68"
          y="249.03"
          width="34.68"
          height="18.51"
          style={{ fill: "#eee4f9", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="255.37"
          y="172.08"
          width="27.82"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="250.96"
          y="195.03"
          width="34.68"
          height="18.51"
          style={{ fill: "#eee4f9", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="245.05"
          y="119.08"
          width="27.82"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="240.64"
          y="142.03"
          width="34.68"
          height="18.51"
          style={{ fill: "#eee4f9", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="250.57"
          y="332.06"
          width="27.82"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="246.16"
          y="355.01"
          width="34.68"
          height="18.51"
          style={{ fill: "#eee4f9", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="259.85"
          y="278.06"
          width="27.82"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="255.44"
          y="301.01"
          width="34.68"
          height="18.51"
          style={{ fill: "#eee4f9", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="251.57"
          y="435.06"
          width="27.82"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="247.16"
          y="458.01"
          width="34.68"
          height="18.51"
          style={{ fill: "#eee4f9", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="260.85"
          y="381.06"
          width="27.82"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="256.44"
          y="404.01"
          width="34.68"
          height="18.51"
          style={{ fill: "#eee4f9", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="260.21"
          y="69.84"
          width="27.82"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="255.8"
          y="92.79"
          width="34.68"
          height="18.51"
          style={{ fill: "#eee4f9", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="417.38"
          y="69.84"
          width="30.64"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="417.82"
          y="122.2"
          width="30.64"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="417.6"
          y="175.02"
          width="30.64"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="418.04"
          y="227.38"
          width="30.64"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="415.36"
          y="279.8"
          width="30.64"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="415.8"
          y="332.16"
          width="30.64"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="415.58"
          y="384.98"
          width="30.64"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="416.02"
          y="437.34"
          width="30.64"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="475.67"
          y="91.03"
          width="22.71"
          height="18.51"
          style={{ fill: "#eee4f9", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="475.57"
          y="144.51"
          width="22.71"
          height="18.51"
          style={{ fill: "#eee4f9", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="475.62"
          y="196.38"
          width="22.71"
          height="18.51"
          style={{ fill: "#eee4f9", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="475.52"
          y="249.86"
          width="22.71"
          height="18.51"
          style={{ fill: "#eee4f9", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="475.62"
          y="301.55"
          width="22.71"
          height="18.51"
          style={{ fill: "#eee4f9", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="475.52"
          y="355.03"
          width="22.71"
          height="18.51"
          style={{ fill: "#eee4f9", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="475.62"
          y="406.77"
          width="22.71"
          height="18.51"
          style={{ fill: "#eee4f9", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="475.52"
          y="460.25"
          width="22.71"
          height="18.51"
          style={{ fill: "#eee4f9", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="165.38"
          y="0.5"
          width={143}
          height="24.98"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="1.5"
          y="25.66"
          width="473.88"
          height="566.78"
          style={{
            fill: "none",
            stroke: "#371c50",
            strokeMiterlimit: 10,
            strokeWidth: "3px"
          }}
        />
        <rect
          x="475.88"
          y="478.94"
          width={11}
          height={115}
          style={{ fill: "#371c50" }}
        />
        <rect
          x="1.88"
          y="576.94"
          width={474}
          height={17}
          style={{ fill: "#371c50" }}
        />
      </g>
      <g id="floors">
        <rect
          id="floor-0"
          x="1.4"
          y="536.79"
          width={474}
          height="57.5"
          style={{ fill: "none" }}
        />
        <rect
          id="floor-2"
          x="0.9"
          y="431.29"
          width="476.5"
          height={53}
          style={{ fill: "none" }}
        />
        <rect
          id="floor-3"
          x="1.4"
          y="378.29"
          width={474}
          height={53}
          style={{ fill: "none" }}
        />
        <rect
          id="floor-4"
          x="3.4"
          y="325.29"
          width={474}
          height={53}
          style={{ fill: "none" }}
        />
        <rect
          id="floor-5"
          x="1.4"
          y="272.29"
          width={474}
          height={53}
          style={{ fill: "none" }}
        />
        <rect
          id="floor-6"
          x="1.4"
          y="220.29"
          width={474}
          height={53}
          style={{ fill: "none" }}
        />
        <rect
          id="floor-7"
          x="1.4"
          y="167.29"
          width={474}
          height={53}
          style={{ fill: "none" }}
        />
        <rect
          id="floor-8"
          x="3.4"
          y="114.29"
          width={474}
          height={53}
          style={{ fill: "none" }}
        />
        <rect
          id="floor-9"
          x="1.4"
          y="61.29"
          width={474}
          height={53}
          style={{ fill: "none" }}
        />
        <rect
          id="floor-10"
          x="1.73"
          y="484.29"
          width={474}
          height="52.29"
          style={{ fill: "none" }}
        />
      </g>
    </svg>
  )
})
export const C2 = forwardRef((props, ref) => {
  return (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 456.46 367.82"
      width="100%"
      {...props}
    >
      <g id="c2">
        <rect
          x="1.46"
          y={266}
          width={454}
          height={100}
          style={{ fill: "#371c50" }}
        />
        <rect
          x="368.54"
          y="109.18"
          width="33.46"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="369.44"
          y="166.18"
          width="33.46"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="371.44"
          y="221.18"
          width="33.46"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="368.44"
          y="60.18"
          width="33.46"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x={188}
          y="0.5"
          width={143}
          height="24.98"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="1.5"
          y="25.5"
          width="453.46"
          height="340.82"
          style={{
            fill: "none",
            stroke: "#371c50",
            strokeMiterlimit: 10,
            strokeWidth: "3px"
          }}
        />
        <rect
          x="20.98"
          y="60.96"
          width="38.11"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="14.94"
          y="83.92"
          width="47.51"
          height="18.51"
          style={{ fill: "#eee4f9", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="20.98"
          y="112.96"
          width="38.11"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="14.94"
          y="135.92"
          width="47.51"
          height="18.51"
          style={{ fill: "#eee4f9", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="20.98"
          y="167.96"
          width="38.11"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="14.94"
          y="190.92"
          width="47.51"
          height="18.51"
          style={{ fill: "#eee4f9", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="20.98"
          y="220.96"
          width="38.11"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="14.94"
          y="243.92"
          width="47.51"
          height="18.51"
          style={{ fill: "#eee4f9", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="90.46"
          y="60.48"
          width="13.64"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="133.46"
          y="60.48"
          width="13.64"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="90.96"
          y="113.48"
          width="13.64"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="133.96"
          y="113.48"
          width="13.64"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="90.96"
          y="170.48"
          width="13.64"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="133.96"
          y="170.48"
          width="13.64"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="90.96"
          y="222.04"
          width="13.64"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="133.96"
          y="222.04"
          width="13.64"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="258.93"
          y="60.91"
          width="13.64"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="301.93"
          y="60.91"
          width="13.64"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="259.43"
          y="113.91"
          width="13.64"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="302.43"
          y="113.91"
          width="13.64"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="259.43"
          y="170.91"
          width="13.64"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="302.43"
          y="170.91"
          width="13.64"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="259.43"
          y="222.48"
          width="13.64"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="302.43"
          y="222.48"
          width="13.64"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="190.04"
          y="113.68"
          width="33.46"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="184.74"
          y="136.63"
          width="41.71"
          height="18.51"
          style={{ fill: "#eee4f9", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="190.94"
          y="170.68"
          width="33.46"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="185.64"
          y="193.63"
          width="41.71"
          height="18.51"
          style={{ fill: "#eee4f9", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="190.94"
          y="221.68"
          width="33.46"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="185.64"
          y="244.63"
          width="41.71"
          height="18.51"
          style={{ fill: "#eee4f9", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="189.94"
          y="60.68"
          width="33.46"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="184.64"
          y="83.63"
          width="41.71"
          height="18.51"
          style={{ fill: "#eee4f9", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="413.54"
          y="109.18"
          width="33.46"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="365.96"
          y="132.13"
          width={84}
          height="18.51"
          style={{ fill: "#eee4f9", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="414.44"
          y="166.18"
          width="33.46"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="365.96"
          y="189.13"
          width="84.9"
          height="18.51"
          style={{ fill: "#eee4f9", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="416.44"
          y="221.18"
          width="33.46"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="365.96"
          y="244.13"
          width="86.9"
          height="18.51"
          style={{ fill: "#eee4f9", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="413.44"
          y="60.18"
          width="33.46"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="365.96"
          y="83.13"
          width="83.9"
          height="18.51"
          style={{ fill: "#eee4f9", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="23.2"
          y="279.72"
          width="14.22"
          height="71.3"
          style={{ fill: "none", stroke: "#eee4f9", strokeMiterlimit: 10 }}
        />
        <rect
          x="78.2"
          y="279.72"
          width="36.04"
          height="71.3"
          style={{ fill: "none", stroke: "#eee4f9", strokeMiterlimit: 10 }}
        />
        <rect
          x="142.33"
          y="279.72"
          width="14.22"
          height="71.3"
          style={{ fill: "none", stroke: "#eee4f9", strokeMiterlimit: 10 }}
        />
        <rect
          x="197.33"
          y="279.72"
          width="36.04"
          height="71.3"
          style={{ fill: "none", stroke: "#eee4f9", strokeMiterlimit: 10 }}
        />
        <rect
          x="276.74"
          y="279.72"
          width="14.22"
          height="71.3"
          style={{ fill: "none", stroke: "#eee4f9", strokeMiterlimit: 10 }}
        />
        <rect
          x="321.74"
          y="279.72"
          width="14.22"
          height="71.3"
          style={{ fill: "none", stroke: "#eee4f9", strokeMiterlimit: 10 }}
        />
      </g>
      <g id="floors">
        <rect
          id="floor-0"
          x="1.19"
          y="270.79"
          width={454}
          height={96}
          style={{ fill: "none" }}
        />
        <rect
          id="floor-1"
          x="1.19"
          y="216.79"
          width={454}
          height={54}
          style={{ fill: "none" }}
        />
        <rect
          id="floor-2"
          x="1.19"
          y="161.79"
          width={454}
          height={54}
          style={{ fill: "none" }}
        />
        <rect
          id="floor-3"
          x="1.19"
          y="107.79"
          width={454}
          height={54}
          style={{ fill: "none" }}
        />
        <rect
          id="floor-4"
          x="1.19"
          y="53.79"
          width={454}
          height={54}
          style={{ fill: "none" }}
        />
      </g>
    </svg>
  )
})
export const C3 = forwardRef((props, ref) => {
  return (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 386.17 472.32"
      width="100%"
      {...props}
    >
      <g id="c3">
        <rect
          x="322.17"
          y="291.46"
          width={64}
          height={180}
          style={{ fill: "#371c50" }}
        />
        <rect
          x="172.17"
          y="291.46"
          width={66}
          height={180}
          style={{ fill: "#371c50" }}
        />
        <rect
          x="1.17"
          y="291.46"
          width={96}
          height={180}
          style={{ fill: "#371c50" }}
        />
        <rect
          x="1.5"
          y="24.99"
          width="373.17"
          height="445.83"
          style={{
            fill: "none",
            stroke: "#371c50",
            strokeMiterlimit: 10,
            strokeWidth: "3px"
          }}
        />
        <rect
          x="7.04"
          y="60.46"
          width="29.55"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="51.04"
          y="60.46"
          width="29.55"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="7.04"
          y="115.46"
          width="29.55"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="51.04"
          y="115.46"
          width="29.55"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="7.04"
          y="165.96"
          width="29.55"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="51.04"
          y="165.96"
          width="29.55"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="7.04"
          y="220.96"
          width="29.55"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="51.04"
          y="220.96"
          width="29.55"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="188.04"
          y="61.68"
          width="29.55"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="188.04"
          y="116.68"
          width="29.55"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="188.04"
          y="167.18"
          width="29.55"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="188.04"
          y="221.18"
          width="29.55"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="328.04"
          y="61.68"
          width="29.55"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="328.04"
          y="116.68"
          width="29.55"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="328.04"
          y="167.18"
          width="29.55"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="328.04"
          y="222.18"
          width="29.55"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="109.98"
          y="60.78"
          width="13.64"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="142.37"
          y="61.04"
          width="13.64"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="109.63"
          y="113.74"
          width="13.64"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="142.02"
          y={114}
          width="13.64"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="109.63"
          y="166.39"
          width="13.64"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="142.02"
          y="166.65"
          width="13.64"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="109.63"
          y="218.83"
          width="13.64"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="142.02"
          y="219.09"
          width="13.64"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="244.72"
          y="62.78"
          width="21.89"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="285.37"
          y="63.04"
          width="13.64"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="244.17"
          y="115.74"
          width="21.89"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="285.02"
          y={116}
          width="13.64"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="244.17"
          y="168.39"
          width="21.89"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="285.02"
          y="168.65"
          width="13.64"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="244.17"
          y="220.83"
          width="21.89"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="285.02"
          y="221.09"
          width="13.64"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="109.8"
          y="270.98"
          width="13.64"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="142.19"
          y="271.24"
          width="13.64"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="244.57"
          y="271.98"
          width="21.89"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="285.43"
          y="272.24"
          width="13.64"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="91.52"
          y="296.4"
          width="86.14"
          height="18.56"
          style={{ fill: "#eee4f9", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="233.75"
          y="296.4"
          width="87.92"
          height="18.51"
          style={{ fill: "#eee4f9", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="7.04"
          y="273.67"
          width="29.55"
          height="18.78"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="51.04"
          y="273.67"
          width="29.55"
          height="18.78"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="188.04"
          y="322.35"
          width="29.55"
          height="41.43"
          style={{ fill: "none", stroke: "#edd7f9", strokeMiterlimit: 10 }}
        />
        <rect
          x="188.04"
          y="373.35"
          width="29.55"
          height="41.43"
          style={{ fill: "none", stroke: "#edd7f9", strokeMiterlimit: 10 }}
        />
        <rect
          x="188.04"
          y="424.85"
          width="29.55"
          height="41.43"
          style={{ fill: "none", stroke: "#edd7f9", strokeMiterlimit: 10 }}
        />
        <rect
          x="142.17"
          y="321.6"
          width="25.43"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="142.17"
          y="372.6"
          width="25.43"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="142.17"
          y="424.1"
          width="25.43"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="102.04"
          y="321.6"
          width="29.55"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="102.04"
          y="372.6"
          width="29.55"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="102.04"
          y="424.1"
          width="29.55"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="7.04"
          y="322.6"
          width="29.55"
          height="41.43"
          style={{ fill: "none", stroke: "#edd7f9", strokeMiterlimit: 10 }}
        />
        <rect
          x="7.04"
          y="373.6"
          width="29.55"
          height="41.43"
          style={{ fill: "none", stroke: "#edd7f9", strokeMiterlimit: 10 }}
        />
        <rect
          x="7.04"
          y="425.1"
          width="29.55"
          height="41.43"
          style={{ fill: "none", stroke: "#edd7f9", strokeMiterlimit: 10 }}
        />
        <rect
          x={51}
          y="321.3"
          width="13.64"
          height="41.43"
          style={{ fill: "none", stroke: "#edd7f9", strokeMiterlimit: 10 }}
        />
        <rect
          x={51}
          y="373.96"
          width="13.64"
          height="41.43"
          style={{ fill: "none", stroke: "#edd7f9", strokeMiterlimit: 10 }}
        />
        <rect
          x={51}
          y="426.39"
          width="13.64"
          height="41.43"
          style={{ fill: "none", stroke: "#edd7f9", strokeMiterlimit: 10 }}
        />
        <rect
          x="287.67"
          y="322.6"
          width="25.43"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="287.67"
          y="373.6"
          width="25.43"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="287.67"
          y="424.1"
          width="25.43"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="244.54"
          y="322.6"
          width="29.55"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="244.54"
          y="373.6"
          width="29.55"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="244.54"
          y="424.1"
          width="29.55"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="336.04"
          y="322.6"
          width="29.55"
          height="41.43"
          style={{ fill: "none", stroke: "#edd7f9", strokeMiterlimit: 10 }}
        />
        <rect
          x="336.04"
          y="373.6"
          width="29.55"
          height="41.43"
          style={{ fill: "none", stroke: "#edd7f9", strokeMiterlimit: 10 }}
        />
        <rect
          x="336.04"
          y="425.1"
          width="29.55"
          height="41.43"
          style={{ fill: "none", stroke: "#edd7f9", strokeMiterlimit: 10 }}
        />
        <rect
          x="188.04"
          y="272.28"
          width="29.55"
          height="20.67"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="327.7"
          y="271.02"
          width="29.55"
          height="21.93"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="142.7"
          y="0.5"
          width="121.1"
          height="25.83"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
      </g>
      <g id="floors">
        <rect
          id="floor-7"
          x="1.04"
          y="52.04"
          width={374}
          height={56}
          style={{ fill: "none" }}
        />
        <rect
          id="floor-6"
          x="1.04"
          y="108.04"
          width={374}
          height={53}
          style={{ fill: "none" }}
        />
        <rect
          id="floor-5"
          x="1.04"
          y="161.04"
          width={374}
          height={53}
          style={{ fill: "none" }}
        />
        <rect
          id="floor-3"
          x="1.04"
          y="267.04"
          width={374}
          height={51}
          style={{ fill: "none" }}
        />
        <rect
          id="floor-2"
          x="1.04"
          y="318.04"
          width={374}
          height={51}
          style={{ fill: "none" }}
        />
        <rect
          id="floor-1"
          x="1.04"
          y="369.04"
          width={374}
          height={51}
          style={{ fill: "none" }}
        />
        <rect
          id="floor-0"
          x="1.04"
          y="420.04"
          width={374}
          height={51}
          style={{ fill: "none" }}
        />
        <rect
          id="floor-4"
          x="2.04"
          y="215.04"
          width={374}
          height={51}
          style={{ fill: "none" }}
        />
      </g>
    </svg>
  )
})
export const C5 = forwardRef((props, ref) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      width="100%"
      viewBox="0 0 769.87 500"
    >
      <g id="elevation_c5">
        <rect
          x="66.92"
          y="53.12"
          width="638"
          height="445.38"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
          strokeWidth="3"
        />
        <rect
          x="491.5"
          y="408.82"
          width="37.21"
          height="74.47"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="221.42"
          y="408.91"
          width="16.54"
          height="74.47"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="260.97"
          y="408.63"
          width="16.54"
          height="74.47"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="310.61"
          y="408.63"
          width="37.21"
          height="74.47"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="365.29"
          y="408.68"
          width="16.54"
          height="74.47"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="404.84"
          y="408.4"
          width="16.54"
          height="74.47"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="438.07"
          y="408.54"
          width="16.54"
          height="74.47"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="543.68"
          y="408.68"
          width="16.54"
          height="74.47"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="583.22"
          y="408.4"
          width="16.54"
          height="74.47"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="616.45"
          y="408.54"
          width="16.54"
          height="74.47"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="189.98"
          y="408.97"
          width="16.54"
          height="74.47"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="136.65"
          y="408.97"
          width="37.21"
          height="74.47"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="667.39"
          y="409.41"
          width="37.21"
          height="74.47"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="75.67"
          y="86.39"
          width="27.82"
          height="41.43"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="71.26"
          y="109.34"
          width="34.68"
          height="18.51"
          fill="#eee4f9"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="76.67"
          y="141.39"
          width="27.82"
          height="41.43"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="72.26"
          y="164.34"
          width="34.68"
          height="18.51"
          fill="#eee4f9"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="76.67"
          y="193.39"
          width="27.82"
          height="41.43"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="72.26"
          y="216.34"
          width="34.68"
          height="18.51"
          fill="#eee4f9"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="77.67"
          y="249.35"
          width="27.82"
          height="41.43"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="73.26"
          y="272.3"
          width="34.68"
          height="18.51"
          fill="#eee4f9"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="76.91"
          y="305.12"
          width="28.02"
          height="33.2"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="147.81"
          y="251"
          width="12.12"
          height="36.12"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="188.76"
          y="250.54"
          width="12.12"
          height="36.12"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="148.28"
          y="301.77"
          width="12.12"
          height="36.12"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="189.23"
          y="301.31"
          width="12.12"
          height="36.12"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="148.05"
          y="146.39"
          width="12.12"
          height="36.12"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="189"
          y="145.92"
          width="12.12"
          height="36.12"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="149.52"
          y="199.16"
          width="12.12"
          height="36.12"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="190.47"
          y="198.69"
          width="12.12"
          height="36.12"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="148.24"
          y="89.08"
          width="12.12"
          height="36.12"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="189.19"
          y="88.61"
          width="12.12"
          height="36.12"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="564.32"
          y="250.26"
          width="12.12"
          height="36.12"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="605.27"
          y="249.8"
          width="12.12"
          height="36.12"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="564.79"
          y="301.03"
          width="12.12"
          height="36.12"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="605.74"
          y="300.57"
          width="12.12"
          height="36.12"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="564.56"
          y="145.65"
          width="12.12"
          height="36.12"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="605.51"
          y="145.19"
          width="12.12"
          height="36.12"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="566.03"
          y="198.42"
          width="12.12"
          height="36.12"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="606.98"
          y="197.95"
          width="12.12"
          height="36.12"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="564.75"
          y="88.34"
          width="12.12"
          height="36.12"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="605.7"
          y="87.87"
          width="12.12"
          height="36.12"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="510.42"
          y="250.81"
          width="17.19"
          height="36.12"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="511.1"
          y="301.58"
          width="17.19"
          height="36.12"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="510.76"
          y="146.2"
          width="17.19"
          height="36.12"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="512.44"
          y="198.97"
          width="17.19"
          height="36.12"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="511.04"
          y="88.89"
          width="17.19"
          height="36.12"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="464.03"
          y="250.54"
          width="12.12"
          height="36.12"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="464.27"
          y="145.93"
          width="12.12"
          height="36.12"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="418.03"
          y="250.54"
          width="12.12"
          height="36.12"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="418.27"
          y="145.93"
          width="12.12"
          height="36.12"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="237.03"
          y="250.54"
          width="12.12"
          height="36.12"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="237.27"
          y="145.93"
          width="12.12"
          height="36.12"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="279.03"
          y="250.54"
          width="12.12"
          height="36.12"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="279.27"
          y="145.93"
          width="12.12"
          height="36.12"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="238.15"
          y="198.24"
          width="35.78"
          height="36.12"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="237.32"
          y="89.24"
          width="35.78"
          height="36.12"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="237.32"
          y="303.41"
          width="35.78"
          height="36.12"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="340.32"
          y="250.41"
          width="35.78"
          height="36.12"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="340.32"
          y="143.41"
          width="35.78"
          height="36.12"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="430.23"
          y="87.89"
          width="35.78"
          height="36.12"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="431.23"
          y="198.89"
          width="35.78"
          height="36.12"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="430.23"
          y="303.89"
          width="35.78"
          height="36.12"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="319.19"
          y="302.02"
          width="12.12"
          height="36.12"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="381.19"
          y="302.02"
          width="12.12"
          height="36.12"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="320.19"
          y="199.02"
          width="12.12"
          height="36.12"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="382.19"
          y="199.02"
          width="12.12"
          height="36.12"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="320.8"
          y="89.41"
          width="12.12"
          height="36.12"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="382.8"
          y="89.41"
          width="12.12"
          height="36.12"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="663.33"
          y="86.09"
          width="40.52"
          height="41.43"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="656.91"
          y="109.04"
          width="50.51"
          height="18.51"
          fill="#eee4f9"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="664.41"
          y="142.09"
          width="40.52"
          height="41.43"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="658"
          y="165.04"
          width="50.51"
          height="18.51"
          fill="#eee4f9"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="662.87"
          y="193.43"
          width="40.52"
          height="41.43"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="654.45"
          y="216.39"
          width="50.51"
          height="18.51"
          fill="#eee4f9"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="661.95"
          y="247.43"
          width="40.52"
          height="41.43"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="655.54"
          y="270.39"
          width="50.51"
          height="18.51"
          fill="#eee4f9"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="663.41"
          y="298"
          width="40.52"
          height="41.43"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="657"
          y="320.95"
          width="50.51"
          height="18.51"
          fill="#eee4f9"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="77.78"
          y="356.81"
          width="28.02"
          height="33.2"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="149.16"
          y="353.46"
          width="12.12"
          height="36.12"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="190.11"
          y="352.99"
          width="12.12"
          height="36.12"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="565.67"
          y="352.72"
          width="12.12"
          height="36.12"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="606.62"
          y="352.26"
          width="12.12"
          height="36.12"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="511.97"
          y="353.27"
          width="17.19"
          height="36.12"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="238.19"
          y="355.1"
          width="35.78"
          height="36.12"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="431.11"
          y="355.57"
          width="35.78"
          height="36.12"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="320.07"
          y="353.7"
          width="12.12"
          height="36.12"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="382.07"
          y="353.7"
          width="12.12"
          height="36.12"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="667.18"
          y="350.26"
          width="36.34"
          height="40.24"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
      </g>
      <g id="interactive_floors">
        <rect
          id="floor_button_0"
          x="66.68"
          y="409"
          width="638"
          height="75"
          fill="none"
        />
        <rect
          id="floor_button_1"
          x="67.68"
          y="345"
          width="638"
          height="54"
          fill="none"
        />
        <rect
          id="floor_button_2"
          x="67.18"
          y="293.5"
          width="638"
          height="53"
          fill="none"
        />
        <rect
          id="floor_button_3"
          x="68.18"
          y="239.5"
          width="638"
          height="54"
          fill="none"
        />
        <rect
          id="floor_button_4"
          x="67.18"
          y="189.5"
          width="638"
          height="50"
          fill="none"
        />
        <rect
          id="floor_button_5"
          x="67.18"
          y="135.5"
          width="638"
          height="53"
          fill="none"
        />
        <rect
          id="floor_button_6"
          x="67.18"
          y="82.5"
          width="638"
          height="53"
          fill="none"
        />
        <rect
          id="floor_circle_3"
          x="0.44"
          y="249.08"
          width="37.82"
          height="37.82"
          rx="18.91"
          fill="#bdb3b7"
        />
        <text
          id="floor_no_3"
          transform="translate(13.33 276.34)"
          fontSize="24.31"
          fill="#fff"
          fontFamily="Lora-Regular, Lora"
        >
          3
        </text>
        <rect
          id="floor_circle_2"
          x="0.44"
          y="301.08"
          width="37.82"
          height="37.82"
          rx="18.91"
          fill="#bdb3b7"
        />
        <text
          id="floor_no_2"
          transform="translate(12.57 329.34)"
          fontSize="24.31"
          fill="#fff"
          fontFamily="Lora-Regular, Lora"
        >
          2
        </text>
        <rect
          id="floor_circle_1"
          x="0.44"
          y="353.08"
          width="37.82"
          height="37.82"
          rx="18.91"
          fill="#bdb3b7"
        />
        <text
          id="floor_no_1"
          transform="translate(14.68 381.34)"
          fontSize="24.31"
          fill="#fff"
          fontFamily="Lora-Regular, Lora"
        >
          1
        </text>
        <rect
          id="floor_circle_0"
          x="0.44"
          y="405.08"
          width="37.82"
          height="37.82"
          rx="18.91"
          fill="#bdb3b7"
        />
        <text
          id="floor_no_0"
          transform="translate(9.85 433.34)"
          fontSize="24.31"
          fill="#fff"
          fontFamily="Lora-Regular, Lora"
        >
          G
        </text>
        <rect
          id="floor_circle_4"
          x="0.44"
          y="197.08"
          width="37.82"
          height="37.82"
          rx="18.91"
          fill="#bdb3b7"
        />
        <text
          id="floor_no_4"
          transform="translate(12.51 224.34)"
          fontSize="24.31"
          fill="#fff"
          fontFamily="Lora-Regular, Lora"
        >
          4
        </text>
        <rect
          id="floor_circle_5"
          x="0.44"
          y="145.08"
          width="37.82"
          height="37.82"
          rx="18.91"
          fill="#bdb3b7"
        />
        <text
          id="floor_no_5"
          transform="translate(12.49 173.34)"
          fontSize="24.31"
          fill="#fff"
          fontFamily="Lora-Regular, Lora"
        >
          5
        </text>
        <rect
          id="floor_circle_6"
          y="92.87"
          width="37.82"
          height="37.82"
          rx="18.91"
          fill="#bdb3b7"
        />
        <text
          id="floor_no_6"
          transform="translate(11.63 121.13)"
          fontSize="24.31"
          fill="#fff"
          fontFamily="Lora-Regular, Lora"
        >
          6
        </text>
        <rect
          id="apt_circle_3"
          x="732.05"
          y="248.87"
          width="37.82"
          height="37.82"
          rx="18.91"
          fill="#857695"
        />
        <text
          id="apt_no_3"
          transform="translate(739.76 276.12)"
          fontSize="24.31"
          fill="#fff"
          fontFamily="Lora-Regular, Lora"
        >
          12
        </text>
        <rect
          id="apt_circle_2"
          x="732.05"
          y="300.87"
          width="37.82"
          height="37.82"
          rx="18.91"
          fill="#857695"
        />
        <text
          id="apt_no_2"
          transform="translate(743.94 329.12)"
          fontSize="24.31"
          fill="#fff"
          fontFamily="Lora-Regular, Lora"
        >
          3
        </text>
        <rect
          id="apt_circle_1"
          x="732.05"
          y="352.87"
          width="37.82"
          height="37.82"
          rx="18.91"
          fill="#857695"
        />
        <text
          id="apt_no_1"
          transform="translate(743.94 380.12)"
          fontSize="24.31"
          fill="#fff"
          fontFamily="Lora-Regular, Lora"
        >
          3
        </text>
        <rect
          id="apt_circle_0"
          x="732.05"
          y="404.87"
          width="37.82"
          height="37.82"
          rx="18.91"
          fill="#857695"
        />
        <text
          id="apt_no_0"
          transform="translate(738.74 432.12)"
          fontSize="24.31"
          fill="#fff"
          fontFamily="Lora-Regular, Lora"
        >
          10
        </text>
        <rect
          id="apt_circle_4"
          x="732.05"
          y="196.87"
          width="37.82"
          height="37.82"
          rx="18.91"
          fill="#857695"
        />
        <text
          id="apt_no_4"
          transform="translate(737.53 224.12)"
          fontSize="24.31"
          fill="#fff"
          fontFamily="Lora-Regular, Lora"
        >
          44
        </text>
        <rect
          id="apt_circle_5"
          x="732.05"
          y="144.87"
          width="37.82"
          height="37.82"
          rx="18.91"
          fill="#857695"
        />
        <text
          id="apt_no_5"
          transform="translate(744.18 173.12)"
          fontSize="24.31"
          fill="#fff"
          fontFamily="Lora-Regular, Lora"
        >
          2
        </text>
        <rect
          id="apt_circle_6"
          x="731.83"
          y="92.48"
          width="37.82"
          height="37.82"
          rx="18.91"
          fill="#857695"
        />
        <text
          id="apt_no_6"
          transform="translate(743.97 120.74)"
          fontSize="24.31"
          fill="#fff"
          fontFamily="Lora-Regular, Lora"
        >
          2
        </text>
        <rect
          id="floor_button_t"
          x="66.68"
          width="638"
          height="53"
          fill="none"
        />
      </g>
    </svg>
  )
})
export const D1 = forwardRef((props, ref) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      width="100%"
      viewBox="0 0 629.03 463.58"
    >
      <g id="elevation_d1">
        <rect
          x="66.75"
          y="21.92"
          width="506"
          height="439.94"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
          strokeWidth="3.43"
        />
        <rect
          x="76.35"
          y="56.56"
          width="29.55"
          height="41.43"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="76.35"
          y="109.56"
          width="29.55"
          height="41.43"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="76.35"
          y="162.22"
          width="29.55"
          height="41.43"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="76.35"
          y="214.65"
          width="29.55"
          height="41.43"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect x="66.75" y="79.82" width="41.92" height="18.51" fill="#eee4f9" />
        <rect
          x="66.75"
          y="79.82"
          width="41.92"
          height="18.51"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="66.75"
          y="133.12"
          width="42.03"
          height="18.51"
          fill="#eee4f9"
        />
        <rect
          x="66.75"
          y="133.12"
          width="42.03"
          height="18.51"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="66.75"
          y="185.53"
          width="41.81"
          height="18.51"
          fill="#eee4f9"
        />
        <rect
          x="66.75"
          y="185.53"
          width="41.81"
          height="18.51"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="66.75"
          y="237.44"
          width="42.09"
          height="18.51"
          fill="#eee4f9"
        />
        <rect
          x="66.75"
          y="237.44"
          width="42.09"
          height="18.51"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="259.72"
          y="109.68"
          width="13.64"
          height="41.43"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="303.09"
          y="112.08"
          width="13.64"
          height="41.43"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="235.9"
          y="162.88"
          width="13.64"
          height="41.43"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="286.27"
          y="163.28"
          width="13.64"
          height="41.43"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="252.81"
          y="213.72"
          width="13.64"
          height="41.43"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="303.18"
          y="214.12"
          width="13.64"
          height="41.43"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="238.99"
          y="55.92"
          width="13.64"
          height="41.43"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="285.36"
          y="56.32"
          width="13.64"
          height="41.43"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="425.73"
          y="109.16"
          width="13.64"
          height="41.43"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="476.1"
          y="109.56"
          width="13.64"
          height="41.43"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="415.92"
          y="163.36"
          width="13.64"
          height="41.43"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="466.29"
          y="163.77"
          width="13.64"
          height="41.43"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="429.83"
          y="214.2"
          width="13.64"
          height="41.43"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="480.2"
          y="214.6"
          width="13.64"
          height="41.43"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="415.01"
          y="56.4"
          width="13.64"
          height="41.43"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="465.38"
          y="56.8"
          width="13.64"
          height="41.43"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="186.82"
          y="273.74"
          width="14.22"
          height="86.98"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
          strokeWidth="1.1"
        />
        <rect
          x="237.04"
          y="274.59"
          width="14.22"
          height="86.98"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
          strokeWidth="1.1"
        />
        <rect
          x="280.72"
          y="274.26"
          width="14.22"
          height="86.98"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
          strokeWidth="1.1"
        />
        <rect
          x="335.72"
          y="274.26"
          width="36.04"
          height="86.98"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
          strokeWidth="1.1"
        />
        <rect
          x="131.75"
          y="275.38"
          width="14.22"
          height="86.98"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
          strokeWidth="1.1"
        />
        <rect
          x="413.5"
          y="274.33"
          width="14.22"
          height="86.98"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
          strokeWidth="1.1"
        />
        <rect
          x="457.17"
          y="274"
          width="14.22"
          height="86.98"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
          strokeWidth="1.1"
        />
        <rect
          x="512.17"
          y="274"
          width="36.04"
          height="86.98"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
          strokeWidth="1.1"
        />
        <rect
          x="143.43"
          y="215.49"
          width="13.64"
          height="41.43"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect x="141.27" y="238.44" width="17" height="18.51" fill="#eee4f9" />
        <rect
          x="141.27"
          y="238.44"
          width="17"
          height="18.51"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="132.43"
          y="164.49"
          width="13.64"
          height="41.43"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect x="130.27" y="187.44" width="17" height="18.51" fill="#eee4f9" />
        <rect
          x="130.27"
          y="187.44"
          width="17"
          height="18.51"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="139.43"
          y="110.49"
          width="13.64"
          height="41.43"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect x="137.27" y="133.44" width="17" height="18.51" fill="#eee4f9" />
        <rect
          x="137.27"
          y="133.44"
          width="17"
          height="18.51"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="131.43"
          y="57.49"
          width="13.64"
          height="41.43"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect x="129.27" y="80.44" width="17" height="18.51" fill="#eee4f9" />
        <rect
          x="129.27"
          y="80.44"
          width="17"
          height="18.51"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="198.43"
          y="214.49"
          width="13.64"
          height="41.43"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect x="196.27" y="237.44" width="17" height="18.51" fill="#eee4f9" />
        <rect
          x="196.27"
          y="237.44"
          width="17"
          height="18.51"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="187.43"
          y="163.49"
          width="13.64"
          height="41.43"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect x="185.27" y="186.44" width="17" height="18.51" fill="#eee4f9" />
        <rect
          x="185.27"
          y="186.44"
          width="17"
          height="18.51"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="194.43"
          y="109.49"
          width="13.64"
          height="41.43"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect x="192.27" y="132.44" width="17" height="18.51" fill="#eee4f9" />
        <rect
          x="192.27"
          y="132.44"
          width="17"
          height="18.51"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="186.43"
          y="56.49"
          width="13.64"
          height="41.43"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect x="184.27" y="79.44" width="17" height="18.51" fill="#eee4f9" />
        <rect
          x="184.27"
          y="79.44"
          width="17"
          height="18.51"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="363.98"
          y="213.49"
          width="27.82"
          height="41.43"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="359.57"
          y="236.44"
          width="34.67"
          height="18.51"
          fill="#eee4f9"
        />
        <rect
          x="359.57"
          y="236.44"
          width="34.67"
          height="18.51"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="341.54"
          y="162.49"
          width="27.82"
          height="41.43"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="337.14"
          y="185.44"
          width="34.67"
          height="18.51"
          fill="#eee4f9"
        />
        <rect
          x="337.14"
          y="185.44"
          width="34.67"
          height="18.51"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="355.82"
          y="108.49"
          width="27.82"
          height="41.43"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="351.42"
          y="131.44"
          width="34.67"
          height="18.51"
          fill="#eee4f9"
        />
        <rect
          x="351.42"
          y="131.44"
          width="34.67"
          height="18.51"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="339.5"
          y="55.49"
          width="27.82"
          height="41.43"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect x="335.1" y="78.44" width="34.67" height="18.51" fill="#eee4f9" />
        <rect
          x="335.1"
          y="78.44"
          width="34.67"
          height="18.51"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="519.66"
          y="57.49"
          width="27.82"
          height="41.43"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="515.26"
          y="80.44"
          width="34.67"
          height="18.51"
          fill="#eee4f9"
        />
        <rect
          x="515.26"
          y="80.44"
          width="34.67"
          height="18.51"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="519.66"
          y="109.49"
          width="27.82"
          height="41.43"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="515.26"
          y="132.44"
          width="34.67"
          height="18.51"
          fill="#eee4f9"
        />
        <rect
          x="515.26"
          y="132.44"
          width="34.67"
          height="18.51"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="519.66"
          y="164.49"
          width="27.82"
          height="41.43"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="515.26"
          y="187.44"
          width="34.67"
          height="18.51"
          fill="#eee4f9"
        />
        <rect
          x="515.26"
          y="187.44"
          width="34.67"
          height="18.51"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="519.66"
          y="216.49"
          width="27.82"
          height="41.43"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="515.26"
          y="239.44"
          width="34.67"
          height="18.51"
          fill="#eee4f9"
        />
        <rect
          x="515.26"
          y="239.44"
          width="34.67"
          height="18.51"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="242.84"
          y="0.5"
          width="143"
          height="20.87"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="89.71"
          y="379.86"
          width="76.19"
          height="65.5"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
          strokeWidth="0.96"
        />
        <rect
          x="192.71"
          y="379.99"
          width="76.19"
          height="65.2"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
          strokeWidth="0.96"
        />
        <rect
          x="363.71"
          y="379.99"
          width="76.19"
          height="65.2"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
          strokeWidth="0.96"
        />
        <rect
          x="471.71"
          y="379.99"
          width="76.19"
          height="65.2"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
          strokeWidth="0.96"
        />
      </g>
      <g id="interactive_floors">
        <rect
          id="apt_circle_3"
          x="591.21"
          y="216.12"
          width="37.82"
          height="37.82"
          rx="18.91"
          fill="#857695"
        />
        <text
          id="apt_no_3"
          transform="translate(598.92 243.38)"
          fontSize="24.31"
          fill="#fff"
          fontFamily="Lora-Regular, Lora"
        >
          12
        </text>
        <rect
          id="apt_circle_2"
          x="591.21"
          y="268.12"
          width="37.82"
          height="37.82"
          rx="18.91"
          fill="#857695"
        />
        <text
          id="apt_no_1"
          transform="translate(603.1 296.38)"
          fontSize="24.31"
          fill="#fff"
          fontFamily="Lora-Regular, Lora"
        >
          3
        </text>
        <rect
          id="apt_circle_1"
          x="591.21"
          y="320.12"
          width="37.82"
          height="37.82"
          rx="18.91"
          fill="#857695"
        />
        <text
          id="apt_no_2"
          transform="translate(603.1 347.38)"
          fontSize="24.31"
          fill="#fff"
          fontFamily="Lora-Regular, Lora"
        >
          3
        </text>
        <rect
          id="apt_circle_0"
          x="591.21"
          y="372.12"
          width="37.82"
          height="37.82"
          rx="18.91"
          fill="#857695"
        />
        <text
          id="apt_no_0"
          transform="translate(597.9 399.38)"
          fontSize="24.31"
          fill="#fff"
          fontFamily="Lora-Regular, Lora"
        >
          10
        </text>
        <rect
          id="apt_circle_4"
          x="591.21"
          y="164.12"
          width="37.82"
          height="37.82"
          rx="18.91"
          fill="#857695"
        />
        <text
          id="apt_no_4"
          transform="translate(596.7 191.38)"
          fontSize="24.31"
          fill="#fff"
          fontFamily="Lora-Regular, Lora"
        >
          44
        </text>
        <rect
          id="apt_circle_5"
          x="591.21"
          y="112.12"
          width="37.82"
          height="37.82"
          rx="18.91"
          fill="#857695"
        />
        <text
          id="apt_no_5"
          transform="translate(603.35 140.38)"
          fontSize="24.31"
          fill="#fff"
          fontFamily="Lora-Regular, Lora"
        >
          2
        </text>
        <rect
          id="apt_circle_6"
          x="591"
          y="59.73"
          width="37.82"
          height="37.82"
          rx="18.91"
          fill="#857695"
        />
        <text
          id="apt_no_6"
          transform="translate(603.13 87.99)"
          fontSize="24.31"
          fill="#fff"
          fontFamily="Lora-Regular, Lora"
        >
          2
        </text>
        <rect
          id="floor_circle_3"
          x="0.44"
          y="215.4"
          width="37.82"
          height="37.82"
          rx="18.91"
          fill="#bdb3b7"
        />
        <text
          id="floor_no_3"
          transform="translate(13.33 242.65)"
          fontSize="24.31"
          fill="#fff"
          fontFamily="Lora-Regular, Lora"
        >
          3
        </text>
        <rect
          id="floor_circle_2"
          x="0.44"
          y="267.4"
          width="37.82"
          height="37.82"
          rx="18.91"
          fill="#bdb3b7"
        />
        <text
          id="floor_no_2"
          transform="translate(12.57 295.65)"
          fontSize="24.31"
          fill="#fff"
          fontFamily="Lora-Regular, Lora"
        >
          2
        </text>
        <rect
          id="floor_circle_1"
          x="0.44"
          y="319.4"
          width="37.82"
          height="37.82"
          rx="18.91"
          fill="#bdb3b7"
        />
        <text
          id="floor_no_1"
          transform="translate(14.68 347.65)"
          fontSize="24.31"
          fill="#fff"
          fontFamily="Lora-Regular, Lora"
        >
          1
        </text>
        <rect
          id="floor_circle_0"
          x="0.44"
          y="371.4"
          width="37.82"
          height="37.82"
          rx="18.91"
          fill="#bdb3b7"
        />
        <text
          id="floor_no_0"
          transform="translate(9.85 399.65)"
          fontSize="24.31"
          fill="#fff"
          fontFamily="Lora-Regular, Lora"
        >
          G
        </text>
        <rect
          id="floor_circle_4"
          x="0.44"
          y="163.4"
          width="37.82"
          height="37.82"
          rx="18.91"
          fill="#bdb3b7"
        />
        <text
          id="floor_no_4"
          transform="translate(12.51 190.65)"
          fontSize="24.31"
          fill="#fff"
          fontFamily="Lora-Regular, Lora"
        >
          4
        </text>
        <rect
          id="floor_circle_5"
          x="0.44"
          y="111.4"
          width="37.82"
          height="37.82"
          rx="18.91"
          fill="#bdb3b7"
        />
        <text
          id="floor_no_5"
          transform="translate(12.49 139.65)"
          fontSize="24.31"
          fill="#fff"
          fontFamily="Lora-Regular, Lora"
        >
          5
        </text>
        <rect
          id="floor_circle_6"
          y="59.19"
          width="37.82"
          height="37.82"
          rx="18.91"
          fill="#bdb3b7"
        />
        <text
          id="floor_no_6"
          transform="translate(11.63 87.44)"
          fontSize="24.31"
          fill="#fff"
          fontFamily="Lora-Regular, Lora"
        >
          6
        </text>
        <rect
          id="floor_button_0"
          x="67.74"
          y="377.4"
          width="502.87"
          height="70.92"
          fill="none"
        />
        <rect
          id="floor_button_1"
          x="67.15"
          y="315.49"
          width="504.42"
          height="47.45"
          fill="none"
        />
        <rect
          id="floor_button_2"
          x="67.15"
          y="264.18"
          width="504.42"
          height="51.31"
          fill="none"
        />
        <rect
          id="floor_button_3"
          x="67.15"
          y="213.12"
          width="504.01"
          height="51.06"
          fill="none"
        />
        <rect
          id="floor_button_4"
          x="67.14"
          y="159.83"
          width="504.22"
          height="53.65"
          fill="none"
        />
        <rect
          id="floor_button_5"
          x="67.14"
          y="104.77"
          width="504.22"
          height="55.06"
          fill="none"
        />
        <rect
          id="floor_button_6"
          x="67.14"
          y="51.65"
          width="504.22"
          height="53.12"
          fill="none"
        />
        <rect
          id="floor_button_t"
          x="67.64"
          y="0.5"
          width="504.22"
          height="43.84"
          fill="none"
        />
      </g>
    </svg>
  )
})
export const D2 = forwardRef((props, ref) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      width="100%"
      viewBox="0 0 562.31 408.15"
    >
      <g id="elevation_d2">
        <rect
          x="79.47"
          y="21.5"
          width="406.77"
          height="385.15"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
          strokeWidth="3"
        />
        <rect
          x="102.59"
          y="57.83"
          width="29.55"
          height="41.43"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="102.59"
          y="110.83"
          width="29.55"
          height="41.43"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="102.59"
          y="161.48"
          width="29.55"
          height="41.43"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="102.59"
          y="213.91"
          width="29.55"
          height="41.43"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="98.71"
          y="81.08"
          width="36.2"
          height="18.51"
          fill="#eee4f9"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="98.82"
          y="134.38"
          width="36.2"
          height="18.51"
          fill="#eee4f9"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="98.6"
          y="184.79"
          width="36.2"
          height="18.51"
          fill="#eee4f9"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="98.88"
          y="236.7"
          width="36.2"
          height="18.51"
          fill="#eee4f9"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="445.83"
          y="58.28"
          width="29.55"
          height="41.43"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="445.83"
          y="109.28"
          width="29.55"
          height="41.43"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="445.83"
          y="161.93"
          width="29.55"
          height="41.43"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="445.83"
          y="214.37"
          width="29.55"
          height="41.43"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="441.96"
          y="81.54"
          width="44.28"
          height="18.51"
          fill="#eee4f9"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="442.07"
          y="132.84"
          width="44.17"
          height="18.51"
          fill="#eee4f9"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="441.84"
          y="185.24"
          width="44.39"
          height="18.51"
          fill="#eee4f9"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="442.12"
          y="237.16"
          width="44.11"
          height="18.51"
          fill="#eee4f9"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="175.66"
          y="57.39"
          width="13.64"
          height="41.43"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="226.03"
          y="57.79"
          width="13.64"
          height="41.43"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="151.84"
          y="110.59"
          width="13.64"
          height="41.43"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="202.21"
          y="108.99"
          width="13.64"
          height="41.43"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="175.75"
          y="161.43"
          width="13.64"
          height="41.43"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="226.12"
          y="161.83"
          width="13.64"
          height="41.43"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="151.93"
          y="214.63"
          width="13.64"
          height="41.43"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="202.3"
          y="214.03"
          width="13.64"
          height="41.43"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="354.33"
          y="58.22"
          width="13.64"
          height="41.43"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="404.7"
          y="58.63"
          width="13.64"
          height="41.43"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="330.52"
          y="109.43"
          width="13.64"
          height="41.43"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="380.89"
          y="109.83"
          width="13.64"
          height="41.43"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="354.42"
          y="162.26"
          width="13.64"
          height="41.43"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="404.79"
          y="162.66"
          width="13.64"
          height="41.43"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="330.61"
          y="215.46"
          width="13.64"
          height="41.43"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="380.98"
          y="214.86"
          width="13.64"
          height="41.43"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="285.96"
          y="58.22"
          width="13.64"
          height="41.43"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="285.96"
          y="111.22"
          width="13.64"
          height="41.43"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="285.96"
          y="161.22"
          width="13.64"
          height="41.43"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="285.96"
          y="215.22"
          width="13.64"
          height="41.43"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="284.24"
          y="83.68"
          width="17"
          height="18.51"
          fill="#eee4f9"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="283.8"
          y="134.52"
          width="17"
          height="18.51"
          fill="#eee4f9"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="283.8"
          y="187.17"
          width="17"
          height="18.51"
          fill="#eee4f9"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="283.8"
          y="238.17"
          width="17"
          height="18.51"
          fill="#eee4f9"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="98.81"
          y="342.15"
          width="81.82"
          height="57.13"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="193.63"
          y="342.15"
          width="80.23"
          height="57.13"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="288.09"
          y="342.15"
          width="80.23"
          height="57.13"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="380.08"
          y="342.15"
          width="80.23"
          height="57.13"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="209.24"
          y="0.5"
          width="143"
          height="20.87"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="173.39"
          y="266.41"
          width="14.22"
          height="64.12"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="216.61"
          y="267.03"
          width="14.22"
          height="64.12"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="256.28"
          y="266.79"
          width="14.22"
          height="64.12"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="308.28"
          y="266.79"
          width="36.04"
          height="64.12"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="401.22"
          y="266.26"
          width="14.22"
          height="64.12"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="446.22"
          y="266.26"
          width="14.22"
          height="64.12"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="99.5"
          y="266.23"
          width="36.04"
          height="64.12"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
      </g>
      <g id="interactive_floors">
        <rect
          id="floor_button_0"
          x="81.31"
          y="353.15"
          width="405"
          height="53"
          fill="none"
        />
        <rect
          id="floor_button_1"
          x="81.31"
          y="307.15"
          width="405"
          height="46"
          fill="none"
        />
        <rect
          id="floor_button_2"
          x="79.31"
          y="262.15"
          width="405"
          height="45"
          fill="none"
        />
        <rect
          id="floor_button_3"
          x="81.31"
          y="210.15"
          width="405"
          height="52"
          fill="none"
        />
        <rect
          id="floor_button_4"
          x="81.31"
          y="158.15"
          width="405"
          height="52"
          fill="none"
        />
        <rect
          id="floor_button_5"
          x="81.31"
          y="106.15"
          width="405"
          height="52"
          fill="none"
        />
        <rect
          id="floor_button_6"
          x="81.31"
          y="54.15"
          width="405"
          height="52"
          fill="none"
        />
        <rect
          id="floor_button_t"
          x="81.31"
          y="1.15"
          width="405"
          height="53"
          fill="none"
        />
        <rect
          id="floor_circle_3"
          x="8.5"
          y="209.35"
          width="37.82"
          height="37.82"
          rx="18.91"
          fill="#bdb3b7"
        />
        <text
          id="floor_no_3"
          transform="translate(20.39 237.61)"
          fontSize="24.31"
          fill="#fff"
          fontFamily="Lora-Regular, Lora"
        >
          3
        </text>
        <rect
          id="floor_circle_2"
          x="8.5"
          y="261.35"
          width="37.82"
          height="37.82"
          rx="18.91"
          fill="#bdb3b7"
        />
        <text
          id="floor_no_2"
          transform="translate(20.63 289.61)"
          fontSize="24.31"
          fill="#fff"
          fontFamily="Lora-Regular, Lora"
        >
          2
        </text>
        <rect
          id="floor_circle_1"
          x="8.5"
          y="313.35"
          width="37.82"
          height="37.82"
          rx="18.91"
          fill="#bdb3b7"
        />
        <text
          id="floor_no_1"
          transform="translate(22.73 341.61)"
          fontSize="24.31"
          fill="#fff"
          fontFamily="Lora-Regular, Lora"
        >
          1
        </text>
        <rect
          id="floor_circle_0"
          x="8.5"
          y="365.35"
          width="37.82"
          height="37.82"
          rx="18.91"
          fill="#bdb3b7"
        />
        <text
          id="floor_no_0"
          transform="translate(17.91 393.61)"
          fontSize="24.31"
          fill="#fff"
          fontFamily="Lora-Regular, Lora"
        >
          G
        </text>
        <rect
          id="floor_circle_4"
          x="8.5"
          y="157.35"
          width="37.82"
          height="37.82"
          rx="18.91"
          fill="#bdb3b7"
        />
        <text
          id="floor_no_4"
          transform="translate(20.57 185.61)"
          fontSize="24.31"
          fill="#fff"
          fontFamily="Lora-Regular, Lora"
        >
          4
        </text>
        <rect
          id="floor_circle_5"
          x="8.5"
          y="105.35"
          width="37.82"
          height="37.82"
          rx="18.91"
          fill="#bdb3b7"
        />
        <text
          id="floor_no_5"
          transform="translate(20.54 133.61)"
          fontSize="24.31"
          fill="#fff"
          fontFamily="Lora-Regular, Lora"
        >
          5
        </text>
        <rect
          id="apt_circle_3"
          x="516.5"
          y="209.35"
          width="37.82"
          height="37.82"
          rx="18.91"
          fill="#bdb3b7"
        />
        <text
          id="apt_no_3"
          transform="translate(524.21 237.61)"
          fontSize="24.31"
          fill="#fff"
          fontFamily="Lora-Regular, Lora"
        >
          12
        </text>
        <rect
          id="apt_circle_2"
          x="516.5"
          y="261.35"
          width="37.82"
          height="37.82"
          rx="18.91"
          fill="#bdb3b7"
        />
        <text
          id="apt_no_2"
          transform="translate(528.39 289.61)"
          fontSize="24.31"
          fill="#fff"
          fontFamily="Lora-Regular, Lora"
        >
          3
        </text>
        <rect
          id="apt_circle_1"
          x="516.5"
          y="313.35"
          width="37.82"
          height="37.82"
          rx="18.91"
          fill="#bdb3b7"
        />
        <text
          id="apt_no_1"
          transform="translate(528.39 341.61)"
          fontSize="24.31"
          fill="#fff"
          fontFamily="Lora-Regular, Lora"
        >
          3
        </text>
        <rect
          id="apt_circle_0"
          x="516.5"
          y="365.35"
          width="37.82"
          height="37.82"
          rx="18.91"
          fill="#bdb3b7"
        />
        <text
          id="apt_no_0"
          transform="translate(523.18 393.61)"
          fontSize="24.31"
          fill="#fff"
          fontFamily="Lora-Regular, Lora"
        >
          10
        </text>
        <rect
          id="apt_circle_4"
          x="516.5"
          y="157.35"
          width="37.82"
          height="37.82"
          rx="18.91"
          fill="#bdb3b7"
        />
        <text
          id="apt_no_4"
          transform="translate(527.61 185.61)"
          fontSize="24.31"
          fill="#fff"
          fontFamily="Lora-Regular, Lora"
        >
          0
        </text>
        <rect
          id="apt_circle_5"
          x="516.5"
          y="105.35"
          width="37.82"
          height="37.82"
          rx="18.91"
          fill="#bdb3b7"
        />
        <text
          id="apt_no_5"
          transform="translate(528.63 133.61)"
          fontSize="24.31"
          fill="#fff"
          fontFamily="Lora-Regular, Lora"
        >
          2
        </text>
        <rect
          id="apt_circle_6"
          x="516.5"
          y="53.35"
          width="37.82"
          height="37.82"
          rx="18.91"
          fill="#bdb3b7"
        />
        <text
          id="apt_no_6"
          transform="translate(528.63 81.61)"
          fontSize="24.31"
          fill="#fff"
          fontFamily="Lora-Regular, Lora"
        >
          2
        </text>
        <rect
          id="floor_circle_6"
          x="8.5"
          y="53.35"
          width="37.82"
          height="37.82"
          rx="18.91"
          fill="#bdb3b7"
        />
        <text
          id="floor_no_6"
          transform="translate(20.13 81.61)"
          fontSize="24.31"
          fill="#fff"
          fontFamily="Lora-Regular, Lora"
        >
          6
        </text>
      </g>
    </svg>
  )
})
export const D3 = forwardRef((props, ref) => {
  return (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 628.16 269.27"
      width="100%"
      {...props}
    >
      <g id="d3">
        <rect
          x="1.5"
          y="1.5"
          width="625.16"
          height="266.27"
          style={{
            fill: "none",
            stroke: "#371c50",
            strokeMiterlimit: 10,
            strokeWidth: "3px"
          }}
        />
        <rect
          x="276.16"
          y={178}
          width="14.68"
          height="74.47"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x={335}
          y="178.72"
          width="14.68"
          height="74.47"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="399.08"
          y="178.44"
          width="14.68"
          height="74.47"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="446.86"
          y="178.44"
          width="37.21"
          height="74.47"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="523.15"
          y="178.5"
          width="14.68"
          height="74.47"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="582.17"
          y="178.35"
          width="14.68"
          height="74.47"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="78.11"
          y="178.53"
          width="14.68"
          height="74.47"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="142.19"
          y="178.26"
          width="14.68"
          height="74.47"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="189.96"
          y="178.26"
          width="37.21"
          height="74.47"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="77.68"
          y="67.36"
          width="13.64"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="124.05"
          y="67.77"
          width="13.64"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="78.92"
          y="118.15"
          width="13.64"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="146.29"
          y="117.55"
          width="13.64"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="294.22"
          y="118.91"
          width="13.64"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="357.59"
          y="118.31"
          width="13.64"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="275.22"
          y="67.91"
          width="13.64"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="338.59"
          y="67.31"
          width="13.64"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="416.41"
          y="118.11"
          width="13.64"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="397.41"
          y="67.11"
          width="13.64"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="546.76"
          y="118.59"
          width="13.64"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="527.76"
          y="67.59"
          width="13.64"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="447.26"
          y="68.09"
          width="41.41"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="461.37"
          y="120.09"
          width="41.41"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="187.7"
          y="67.7"
          width="41.41"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="213.82"
          y="119.7"
          width="41.41"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="575.76"
          y="67.7"
          width="41.41"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="75.16"
          y={38}
          width={553}
          height={30}
          style={{ fill: "#371c50" }}
        />
        <rect
          x="601.47"
          y="118.75"
          width="13.64"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
      </g>
      <g id="floors">
        <rect
          id="floor-0"
          x="1.04"
          y="215.51"
          width={626}
          height={53}
          style={{ fill: "none" }}
        />
        <rect
          id="floor-2"
          x="1.04"
          y="113.51"
          width={626}
          height={51}
          style={{ fill: "none" }}
        />
        <rect
          id="floor-3"
          x="1.04"
          y="54.51"
          width={626}
          height={59}
          style={{ fill: "none" }}
        />
        <rect
          id="floor-1"
          x="1.04"
          y="162.51"
          width={626}
          height={53}
          style={{ fill: "none" }}
        />
      </g>
    </svg>
  )
})
export const D5 = forwardRef((props, ref) => {
  return (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 389.34 473.46"
      width="100%"
      {...props}
    >
      <g id="d5">
        <rect
          x="14.67"
          y="25.94"
          width="373.17"
          height="445.83"
          style={{
            fill: "none",
            stroke: "#371c50",
            strokeMiterlimit: 10,
            strokeWidth: "3px"
          }}
        />
        <rect
          x="128.54"
          y="0.5"
          width="125.96"
          height="25.83"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="36.79"
          y="61.95"
          width="29.55"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="36.79"
          y="115.95"
          width="29.55"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="36.79"
          y="168.45"
          width="29.55"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="36.79"
          y="219.45"
          width="29.55"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="36.79"
          y="272.83"
          width="29.55"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="178.79"
          y="61.39"
          width="29.55"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="178.79"
          y="115.39"
          width="29.55"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="178.79"
          y="167.89"
          width="29.55"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="178.79"
          y="218.89"
          width="29.55"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="178.79"
          y="273.27"
          width="29.55"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="33.49"
          y="86.26"
          width="37.01"
          height="18.56"
          style={{ fill: "#eee4f9", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="33.06"
          y="139.26"
          width="37.01"
          height="18.56"
          style={{ fill: "#eee4f9", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="33.76"
          y="193.13"
          width="37.01"
          height="18.56"
          style={{ fill: "#eee4f9", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="33.32"
          y="244.13"
          width="37.01"
          height="18.56"
          style={{ fill: "#eee4f9", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="175.63"
          y="85.76"
          width="37.01"
          height="18.56"
          style={{ fill: "#eee4f9", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="175.19"
          y="138.76"
          width="37.01"
          height="18.56"
          style={{ fill: "#eee4f9", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="175.89"
          y="192.63"
          width="37.01"
          height="18.56"
          style={{ fill: "#eee4f9", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="175.46"
          y="243.63"
          width="37.01"
          height="18.56"
          style={{ fill: "#eee4f9", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect y="296.46" width={73} height={177} style={{ fill: "#371c50" }} />
        <rect
          x="33.54"
          y="297.79"
          width="37.01"
          height="18.56"
          style={{ fill: "#eee4f9" }}
        />
        <rect
          x="93.37"
          y="62.68"
          width="13.64"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="93.02"
          y="115.64"
          width="13.64"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="93.02"
          y="169.29"
          width="13.64"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="93.02"
          y="218.73"
          width="13.64"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="93.43"
          y="272.88"
          width="13.64"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="125.38"
          y="62.68"
          width="21.89"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="124.82"
          y="114.64"
          width="21.89"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="124.82"
          y="169.29"
          width="21.89"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="124.82"
          y="218.73"
          width="21.89"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="125.22"
          y="272.88"
          width="21.89"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="273.37"
          y="61.68"
          width="13.64"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="273.02"
          y="115.64"
          width="13.64"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="273.02"
          y="169.29"
          width="13.64"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="273.02"
          y="218.73"
          width="13.64"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="273.43"
          y="274.88"
          width="13.64"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="330.46"
          y="61.68"
          width="13.64"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="330.11"
          y="115.64"
          width="13.64"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="330.11"
          y="169.29"
          width="13.64"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="330.11"
          y="218.73"
          width="13.64"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="330.51"
          y="272.88"
          width="13.64"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="359.46"
          y="61.68"
          width="13.64"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="359.11"
          y="115.64"
          width="13.64"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="359.11"
          y="169.29"
          width="13.64"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="359.11"
          y="218.73"
          width="13.64"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="359.51"
          y="272.88"
          width="13.64"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="315.5"
          y="87.72"
          width={71}
          height="18.56"
          style={{ fill: "#eee4f9", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="315.89"
          y="139.72"
          width={71}
          height="18.56"
          style={{ fill: "#eee4f9", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="315.89"
          y="192.72"
          width={71}
          height="18.56"
          style={{ fill: "#eee4f9", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="315.89"
          y="243.29"
          width={71}
          height="18.56"
          style={{ fill: "#eee4f9", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="315.89"
          y="298.29"
          width={71}
          height="18.56"
          style={{ fill: "#eee4f9", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="175.89"
          y="298.29"
          width="37.01"
          height="18.56"
          style={{ fill: "#eee4f9", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="78.01"
          y="322.82"
          width="29.55"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="78.01"
          y="374.82"
          width="29.55"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="78.01"
          y="426.21"
          width="29.55"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="75.1"
          y="347.57"
          width="37.01"
          height="18.56"
          style={{ fill: "#eee4f9", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="74.67"
          y="399.57"
          width="37.01"
          height="18.56"
          style={{ fill: "#eee4f9", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="74.1"
          y="452.22"
          width="37.01"
          height="18.56"
          style={{ fill: "#eee4f9", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="120.62"
          y="322.82"
          width="34.98"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="121.62"
          y="374.82"
          width="34.98"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="120.62"
          y="427.21"
          width="34.98"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="117.18"
          y="347.57"
          width="43.82"
          height="18.56"
          style={{ fill: "#eee4f9", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="117.67"
          y="399.57"
          width="43.82"
          height="18.56"
          style={{ fill: "#eee4f9", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="117.18"
          y="452.22"
          width="43.82"
          height="18.56"
          style={{ fill: "#eee4f9", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="227.72"
          y="323.32"
          width="13.64"
          height="40.91"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="227.72"
          y="375.09"
          width="13.64"
          height="40.91"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="228.12"
          y="426.56"
          width="13.64"
          height="40.91"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="254.72"
          y="323.32"
          width="13.64"
          height="40.91"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="254.72"
          y="375.09"
          width="13.64"
          height="40.91"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="256.12"
          y="426.56"
          width="13.64"
          height="40.91"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="279.72"
          y="323.3"
          width="13.64"
          height="40.91"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="280.72"
          y="375.08"
          width="13.64"
          height="40.91"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="281.12"
          y="426.54"
          width="13.64"
          height="40.91"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="178.36"
          y="322.85"
          width="29.55"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="179.36"
          y="375.85"
          width="29.55"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="178.36"
          y="426.23"
          width="29.55"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="312.84"
          y="323.5"
          width="29.55"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="357.84"
          y="323.5"
          width="29.55"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="312.84"
          y="375.5"
          width="29.55"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="357.84"
          y="375.5"
          width="29.55"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="312.88"
          y="426.35"
          width="29.55"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
        <rect
          x="357.88"
          y="426.35"
          width="29.55"
          height="41.43"
          style={{ fill: "none", stroke: "#371c50", strokeMiterlimit: 10 }}
        />
      </g>
      <g id="floors">
        <rect
          id="floor-0"
          x="14.63"
          y="421.61"
          width={373}
          height={50}
          style={{ fill: "none" }}
        />
        <rect
          id="floor-1"
          x="14.63"
          y="370.61"
          width={373}
          height={50}
          style={{ fill: "none" }}
        />
        <rect
          id="floor-2"
          x="14.63"
          y="320.61"
          width={373}
          height={50}
          style={{ fill: "none" }}
        />
        <rect
          id="floor-3"
          x="14.63"
          y="267.61"
          width={373}
          height={52}
          style={{ fill: "none" }}
        />
        <rect
          id="floor-4"
          x="14.63"
          y="215.61"
          width={373}
          height={52}
          style={{ fill: "none" }}
        />
        <rect
          id="floor-5"
          x="14.63"
          y="163.61"
          width={373}
          height={52}
          style={{ fill: "none" }}
        />
        <rect
          id="floor-6"
          x="15.63"
          y="110.61"
          width={373}
          height={52}
          style={{ fill: "none" }}
        />
        <rect
          id="floor-7"
          x="15.63"
          y="57.61"
          width={373}
          height={52}
          style={{ fill: "none" }}
        />
      </g>
    </svg>
  )
})
export const E1 = forwardRef((props, ref) => {
  return (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      viewBox="0 0 490.67 410.16"
    >
      <g id="elevation_e1">
        <rect
          x="58.75"
          y="35.5"
          width="373.17"
          height="373.16"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
          strokeWidth="3"
        />
        <rect
          x="291.61"
          y="8.39"
          width="125.96"
          height="25.83"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="80.87"
          y="52.84"
          width="29.55"
          height="41.43"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="80.87"
          y="105.34"
          width="29.55"
          height="41.43"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="80.87"
          y="156.34"
          width="29.55"
          height="41.43"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="80.87"
          y="209.72"
          width="29.55"
          height="41.43"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="222.87"
          y="52.28"
          width="29.55"
          height="41.43"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="222.87"
          y="104.78"
          width="29.55"
          height="41.43"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="222.87"
          y="155.78"
          width="29.55"
          height="41.43"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="222.87"
          y="210.16"
          width="29.55"
          height="41.43"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="77.14"
          y="76.16"
          width="37.01"
          height="18.56"
          fill="#eee4f9"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="77.83"
          y="130.03"
          width="37.01"
          height="18.56"
          fill="#eee4f9"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="77.4"
          y="181.03"
          width="37.01"
          height="18.56"
          fill="#eee4f9"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="219.27"
          y="75.66"
          width="37.01"
          height="18.56"
          fill="#eee4f9"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="219.96"
          y="129.53"
          width="37.01"
          height="18.56"
          fill="#eee4f9"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="219.53"
          y="180.53"
          width="37.01"
          height="18.56"
          fill="#eee4f9"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="77.62"
          y="234.68"
          width="37.01"
          height="18.56"
          fill="#eee4f9"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="137.1"
          y="52.53"
          width="13.64"
          height="41.43"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="137.1"
          y="106.19"
          width="13.64"
          height="41.43"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="137.1"
          y="155.62"
          width="13.64"
          height="41.43"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <polygon
          points="151.14 251.21 137.5 251.21 137.5 209.77 151.14 209.77 151.14 247.53 151.14 251.21"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="168.89"
          y="51.53"
          width="21.89"
          height="41.43"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="168.89"
          y="106.19"
          width="21.89"
          height="41.43"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="168.89"
          y="155.62"
          width="21.89"
          height="41.43"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="169.3"
          y="209.77"
          width="21.89"
          height="41.43"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="317.1"
          y="52.53"
          width="13.64"
          height="41.43"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="317.1"
          y="106.19"
          width="13.64"
          height="41.43"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="317.1"
          y="155.62"
          width="13.64"
          height="41.43"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="317.5"
          y="211.77"
          width="13.64"
          height="41.43"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="374.18"
          y="52.53"
          width="13.64"
          height="41.43"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="374.18"
          y="106.19"
          width="13.64"
          height="41.43"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="374.18"
          y="155.62"
          width="13.64"
          height="41.43"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="374.59"
          y="209.77"
          width="13.64"
          height="41.43"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="403.18"
          y="52.53"
          width="13.64"
          height="41.43"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="403.18"
          y="106.19"
          width="13.64"
          height="41.43"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="403.18"
          y="155.62"
          width="13.64"
          height="41.43"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="403.59"
          y="209.77"
          width="13.64"
          height="41.43"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="359.97"
          y="76.61"
          width="71"
          height="18.56"
          fill="#eee4f9"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="359.97"
          y="129.61"
          width="71"
          height="18.56"
          fill="#eee4f9"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="359.97"
          y="180.18"
          width="71"
          height="18.56"
          fill="#eee4f9"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="359.97"
          y="235.18"
          width="71"
          height="18.56"
          fill="#eee4f9"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="219.96"
          y="235.18"
          width="37.01"
          height="18.56"
          fill="#eee4f9"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="122.08"
          y="259.72"
          width="29.55"
          height="41.43"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="122.08"
          y="311.72"
          width="29.55"
          height="41.43"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="122.08"
          y="363.1"
          width="29.55"
          height="41.43"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="119.18"
          y="284.47"
          width="37.01"
          height="18.56"
          fill="#eee4f9"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="118.75"
          y="336.47"
          width="37.01"
          height="18.56"
          fill="#eee4f9"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="118.18"
          y="389.12"
          width="37.01"
          height="18.56"
          fill="#eee4f9"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="164.7"
          y="259.72"
          width="34.98"
          height="41.43"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="165.7"
          y="311.72"
          width="34.98"
          height="41.43"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="164.7"
          y="364.1"
          width="34.98"
          height="41.43"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="161.26"
          y="284.47"
          width="43.82"
          height="18.56"
          fill="#eee4f9"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="161.75"
          y="336.47"
          width="43.82"
          height="18.56"
          fill="#eee4f9"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="161.26"
          y="389.12"
          width="43.82"
          height="18.56"
          fill="#eee4f9"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="271.79"
          y="260.21"
          width="13.64"
          height="40.91"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="271.79"
          y="311.98"
          width="13.64"
          height="40.91"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="272.2"
          y="363.45"
          width="13.64"
          height="40.91"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="298.79"
          y="260.21"
          width="13.64"
          height="40.91"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="298.79"
          y="311.98"
          width="13.64"
          height="40.91"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="300.2"
          y="363.45"
          width="13.64"
          height="40.91"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="323.79"
          y="260.2"
          width="13.64"
          height="40.91"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="324.79"
          y="311.97"
          width="13.64"
          height="40.91"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="325.2"
          y="363.44"
          width="13.64"
          height="40.91"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="222.43"
          y="259.74"
          width="29.55"
          height="41.43"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="223.43"
          y="312.74"
          width="29.55"
          height="41.43"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="222.43"
          y="363.12"
          width="29.55"
          height="41.43"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="356.91"
          y="260.39"
          width="29.55"
          height="41.43"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="401.91"
          y="260.39"
          width="29.55"
          height="41.43"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="356.91"
          y="312.39"
          width="29.55"
          height="41.43"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="401.91"
          y="312.39"
          width="29.55"
          height="41.43"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="356.95"
          y="363.24"
          width="29.55"
          height="41.43"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="401.95"
          y="363.24"
          width="29.55"
          height="41.43"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="84.45"
          y="261.87"
          width="13.64"
          height="41.43"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="84.45"
          y="311.31"
          width="13.64"
          height="41.43"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <rect
          x="84.25"
          y="361.48"
          width="13.64"
          height="41.43"
          fill="none"
          stroke="#371c50"
          strokeMiterlimit="10"
        />
        <text
          transform="translate(468.38 294.47)"
          font-size="27.27"
          fill="#fff"
          font-family="Lora-Regular, Lora"
        >
          2
        </text>
        <text
          transform="translate(468.24 241.87)"
          font-size="27.27"
          fill="#fff"
          font-family="Lora-Regular, Lora"
        >
          3
        </text>
        <text
          transform="translate(466.76 189.82)"
          font-size="27.27"
          fill="#fff"
          font-family="Lora-Regular, Lora"
        >
          4
        </text>
      </g>
      <g id="interactive_floors">
        <rect
          id="floor_button_0"
          x="58.7"
          y="358"
          width="373"
          height="50.5"
          fill="none"
        />
        <rect
          id="floor_button_1"
          x="58.7"
          y="307.5"
          width="373"
          height="50.5"
          fill="none"
        />
        <rect
          id="floor_button_2"
          x="58.7"
          y="257.5"
          width="373"
          height="50"
          fill="none"
        />
        <rect
          id="floor_button_3"
          x="58.7"
          y="204.5"
          width="373"
          height="53.5"
          fill="none"
        />
        <rect
          id="floor_button_4"
          x="58.7"
          y="152"
          width="373"
          height="52.5"
          fill="none"
        />
        <rect
          id="floor_button_5"
          x="58.7"
          y="99"
          width="373"
          height="53"
          fill="none"
        />
        <rect
          id="floor_button_6"
          x="58.7"
          y="47.5"
          width="373"
          height="52"
          fill="none"
        />
        <rect
          id="floor_circle_3"
          y="207.41"
          width="37.82"
          height="37.82"
          rx="18.91"
          fill="#bdb3b7"
        />
        <text
          id="floor_no_3"
          transform="translate(11.89 235.67)"
          font-size="24.31"
          fill="#fff"
          font-family="Lora-Regular, Lora"
        >
          3
        </text>
        <rect
          id="floor_circle_2"
          y="259.41"
          width="37.82"
          height="37.82"
          rx="18.91"
          fill="#bdb3b7"
        />
        <text
          id="floor_no_2"
          transform="translate(12.13 287.67)"
          font-size="24.31"
          fill="#fff"
          font-family="Lora-Regular, Lora"
        >
          2
        </text>
        <rect
          id="floor_circle_1"
          y="311.41"
          width="37.82"
          height="37.82"
          rx="18.91"
          fill="#bdb3b7"
        />
        <text
          id="floor_no_1"
          transform="translate(14.24 339.67)"
          font-size="24.31"
          fill="#fff"
          font-family="Lora-Regular, Lora"
        >
          1
        </text>
        <rect
          id="floor_circle_0"
          y="363.41"
          width="37.82"
          height="37.82"
          rx="18.91"
          fill="#bdb3b7"
        />
        <text
          id="floor_no_0"
          transform="translate(9.41 391.67)"
          font-size="24.31"
          fill="#fff"
          font-family="Lora-Regular, Lora"
        >
          G
        </text>
        <rect
          id="floor_circle_4"
          y="155.41"
          width="37.82"
          height="37.82"
          rx="18.91"
          fill="#bdb3b7"
        />
        <text
          id="floor_no_4"
          transform="translate(12.07 183.67)"
          font-size="24.31"
          fill="#fff"
          font-family="Lora-Regular, Lora"
        >
          4
        </text>
        <rect
          id="floor_circle_5"
          y="103.41"
          width="37.82"
          height="37.82"
          rx="18.91"
          fill="#bdb3b7"
        />
        <text
          id="floor_no_5"
          transform="translate(12.05 131.67)"
          font-size="24.31"
          fill="#fff"
          font-family="Lora-Regular, Lora"
        >
          5
        </text>
        <rect
          id="floor_circle_6"
          x="0.34"
          y="51.78"
          width="37.82"
          height="37.82"
          rx="18.91"
          fill="#bdb3b7"
        />
        <text
          id="floor_no_6"
          transform="translate(11.97 80.03)"
          font-size="24.31"
          fill="#fff"
          font-family="Lora-Regular, Lora"
        >
          6
        </text>
        <rect
          id="apt_circle_3"
          x="452.79"
          y="211.53"
          width="37.82"
          height="37.82"
          rx="18.91"
          fill="#857695"
        />
        <text
          id="apt_no_3"
          transform="translate(463.9 239.79)"
          font-size="24.31"
          fill="#fff"
          font-family="Lora-Regular, Lora"
        >
          0
        </text>
        <rect
          id="apt_circle_2"
          x="452.79"
          y="263.53"
          width="37.82"
          height="37.82"
          rx="18.91"
          fill="#857695"
        />
        <text
          id="apt_no_2"
          transform="translate(463.9 291.79)"
          font-size="24.31"
          fill="#fff"
          font-family="Lora-Regular, Lora"
        >
          0
        </text>
        <rect
          id="apt_circle_1"
          x="452.79"
          y="315.53"
          width="37.82"
          height="37.82"
          rx="18.91"
          fill="#857695"
        />
        <text
          id="apt_no_1"
          transform="translate(463.9 343.79)"
          font-size="24.31"
          fill="#fff"
          font-family="Lora-Regular, Lora"
        >
          0
        </text>
        <rect
          id="apt_circle_0"
          x="452.79"
          y="367.53"
          width="37.82"
          height="37.82"
          rx="18.91"
          fill="#857695"
        />
        <text
          id="apt_no_0"
          transform="translate(463.9 395.79)"
          font-size="24.31"
          fill="#fff"
          font-family="Lora-Regular, Lora"
        >
          0
        </text>
        <rect
          id="apt_circle_4"
          x="452.79"
          y="159.53"
          width="37.82"
          height="37.82"
          rx="18.91"
          fill="#857695"
        />
        <text
          id="apt_no_4"
          transform="translate(463.9 187.79)"
          font-size="24.31"
          fill="#fff"
          font-family="Lora-Regular, Lora"
        >
          0
        </text>
        <rect
          id="apt_circle_5"
          x="452.79"
          y="107.53"
          width="37.82"
          height="37.82"
          rx="18.91"
          fill="#857695"
        />
        <text
          id="apt_no_5"
          transform="translate(463.9 135.79)"
          font-size="24.31"
          fill="#fff"
          font-family="Lora-Regular, Lora"
        >
          0
        </text>
        <rect
          id="apt_circle_6"
          x="452.85"
          y="57.53"
          width="37.82"
          height="37.82"
          rx="18.91"
          fill="#857695"
        />
        <text
          id="apt_no_6"
          transform="translate(463.96 85.79)"
          font-size="24.31"
          fill="#fff"
          font-family="Lora-Regular, Lora"
        >
          0
        </text>
        <rect
          id="floor_button_t"
          x="60.2"
          width="370"
          height="36.11"
          fill="none"
        />
      </g>
    </svg>
  )
})
